import { Phone } from '../../node_modules/lucide-react/dist/lucide-react';

/**
 * Instructions
 * naming convintion (snake_case,lowercase,no appriviations) ex: basic_information
 * write your strings after your name
 * left 2 empty lines after your strings
 * when merge just left the previous as it is and take all of your strings (after your name tell the next name)...
 * ...copy and replace your previous strings with the current version
 */
export const MultilanguageText = {
  en: {
    // Hosny
    basic_information: 'Basic information',
    name: 'Name',
    notes: 'Notes',
    change_password: 'Change password',
    current_password: 'Current password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    uppercase_letter: 'Uppercase letter',
    lowercase_letter: 'Lowercase letter',
    at_least_one_number: 'At least one number',
    special_character: 'Special character',
    eight_character_minimum_length: '8-character minimum length',
    update_password: 'Update password',
    profile: 'Profile',
    availability: 'Availability',
    security: 'Security',
    settings: 'Settings',
    availability_settings: 'Availability settings',
    working_hours: 'Working hours',
    break_time: 'Break time',
    busy_dates: 'Busy dates',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    to: 'to',
    save_changes: 'Save changes',
    save_availability: 'Save availability',
    failed_to_update_profile: 'Failed to update profile',
    failed_to_update_password: 'Failed to update password',
    failed_to_update_availability: 'Failed to update availability',
    failed_to_update_settings: 'Failed to update settings',
    availability_updated_successfully: 'Availability updated successfully',
    profile_updated_successfully: 'Profile updated successfully',
    password_updated_successfully: 'Password updated successfully',
    settings_updated_successfully: 'Settings updated successfully',
    new_password_dont_match: 'New password and confirm password do not match',
    incorrect_username_or_password: 'Incorrect username or password',
    loading: 'Loading...',
    access_denied: 'Access denied',
    you_do_not_have_permission_to_access_this_page:
      'You do not have permission to access this page',
    analytics_dashboard: 'Analytics dashboard',
    all_providers: 'All providers',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    total_tickets: 'Total tickets',
    total: 'Total',
    completed_tickets: 'Completed tickets',
    completed_appointments: 'Completed appointments',
    completion_rate: 'Completion rate',
    avg_response_time: 'Avg response time',
    m: 'm',
    average_time_to_first_response: 'Average time to first response',
    tickets_by_status: 'Tickets by status',
    appointments_by_status: 'Appointments by status',
    appointment_distribution: 'Appointment distribution',
    ticket_timeline: 'Ticket timeline',
    appointment_timeline: 'Appointment timeline',
    patient_demographics: 'Patient demographics',
    gender_distribution: 'Gender distribution',
    male: 'Male',
    female: 'Female',
    age_groups: 'Age groups',
    count: 'Count',
    performance_summary: 'Performance summary',
    average_response_time: 'Average response time',
    minutes: 'minutes',
    minute: 'minute',
    date_range_summary: 'Date range summary',
    time_period: 'Time period',
    total_days: 'Total days',
    grouping: 'Grouping',
    completed: 'Completed',
    pending: 'Pending',
    'in-progress': 'In progress',
    cancelled: 'Cancelled',
    un_known: 'Un-known',
    unknown: 'Un-known',
    initial: 'Initial',
    followup: 'Follow-up',
    routine: 'Routine',
    urgent: 'Urgent',
    profile_settings: 'Profile settings',
    adim_dashboard: 'Admin dashboard',
    sign_out: 'Sign out',
    open_user_menu: 'Open user menu',
    notifications: 'Notifications',
    change_language: 'Change language',
    contextual_insights: 'Contextual insights',
    total_appointments: 'Total Appointments',
    recent_health_records: 'Recent Health Records',
    last_check_up: 'Last Check-up',
    click_regerate: 'Click "Generate Insights" to get AI-powered health analysis',
    blood_sugar: 'Blood Sugar',
    heart_rate: 'Heart Rate',
    weight: 'Weight',
    blood_pressure: 'Blood Pressure',
    key_health_metrics: 'Key Health Metrics',
    ai_clinical_insights: 'AI Clinical Insights',
    moderate_health_risk: 'Moderate Health Risk',
    overall_health_risk_score: 'Overall Health Risk Score',
    generating: 'Generating...',
    regenerate_insights: 'Regenerate Insights',
    generate_insights: 'Generate Insights',
    no_recent_records: 'No recent records found',
    comprehensive_health_narrative: 'Comprehensive Health Narrative',
    low_risk: 'Low Risk',
    high_risk: 'High Risk',
    moderate_risk: 'Moderate Risk',
    moderate_smoking: 'Moderate ',
    mmHg: 'mmHg',
    bpm: 'bpm',
    mg_dL: 'mg/dL',
    kg: 'kg',
    g: 'g',
    L: 'L',
    edit_health_record: 'Edit Health Record',
    new_health_record: 'New Health Record',
    temperature: 'Temperature',
    fasting_insulin: 'Fasting Insulin',
    hba1c: 'HbA1c',
    post_prandial_glucose: 'Post-Prandial Glucose',
    hdl: 'HDL',
    ldl: 'LDL',
    microalbumin: 'Microalbumin',
    egfr: 'EGFR',
    carbIntake: 'Carb Intake',
    water_intake: 'Water Intake',
    diet_type: 'Diet Type',
    exercise_minutes: 'Exercise Minutes',
    daily_steps: 'Daily Steps',
    sleep_hours: 'Sleep Hours',
    medication: 'Medication',
    no_changes_detected_in_health_metrics: 'No changes detected in health metrics',
    failed_to_update_health_metrics: 'Failed to update health metrics',
    quick_add_health_record: 'Quick Add Health Record',
    or: 'or',
    vitals: 'Vitals',
    diabetes: 'Diabetes',
    cardiovascular: 'Cardiovascular',
    kidney: 'Kidney',
    c: '°C',
    cm: 'cm',
    BMI: 'BMI',
    calculated: 'Calculated',
    fasting_blood_sugar: 'Fasting Blood Sugar',
    mui: 'µIU/mL',
    mg_L: 'mg/L',
    eGFR: 'eGFR',
    units: 'mL/min/1.73m²',
    exercise_frequency: 'Exercise Frequency',
    select_exercise_frequency: 'Select Exercise Frequency',
    sedentary: 'Sedentary (little to no exercise)',
    light: 'Light (1-3 days/week)',
    moderate: 'Moderate (3-5 days/week)',
    active_exercise: 'Active (6-7 days/week)',
    very_active: 'Very Active (multiple times daily)',
    select_diet_type: 'Select Diet Type',
    balanced_diet: 'Balanced Diet',
    vegetarian: 'Vegetarian',
    vegan: 'Vegan',
    ketogenic: 'Ketogenic',
    mediterranean: 'Mediterranean',
    paleo: 'Paleo',
    other: 'Other',
    stress_level1_10: 'Stress Level (1-10)',
    record_type: 'Record Type',
    follow_up_visit: 'Follow-up Visit',
    specialist_consultation: 'Specialist Consultation',
    emergency_visit: 'Emergency Visit',
    lab_results: 'Lab Results',
    telemedicine_visit: 'Telemedicine Visit',
    current_symptoms: 'Current Symptoms',
    clinical_notes: 'Clinical Notes',
    required_fields: 'Required fields:',
    saving: 'Saving...',
    update_record: 'Update Record',
    rate_your_stress_level: 'Rate your stress level',
    describe_any_current_symptoms_or_complaincts: 'Desribe any current symptoms or complaints...',
    list_all_current_medications_and_dosages: 'List all current medications and dosages...',
    add_any_clinical_observations_treatment_plans_or_follow_up_recommendations:
      'Add any clinical observations, treatment plans, or follow-up recommendations...',
    export_patients: 'Export patients',
    added_filters: 'Applied filters',
    export_patient_feilds: 'Fields: Basic info, Name, Number, Email',
    failed_to_load_patient_data: 'Failed to load patient data',
    failed_to_load_provider: 'Failed to load providers',
    failed_to_search_patients: 'Failed to search patients',
    failed_to_check_provider_avaialability: 'Failed to check provider availability',
    appointment_created_successfully: 'Appointment created successfully',
    failed_to_create_meeting_link: 'Failed to create meeting link',
    couldn_t_create_ticket: 'Couldnt create appointment',
    no_permission_to_update_ticket: 'You do not have permission to update this ticket',
    active_profile: 'Active',
    inactive_profile: 'Inactive',
    date_time: 'Date & Time',
    join_call: 'Join call',
    cancel_appointment: 'Cancel appointment',
    by: 'by',
    failed_to_load_hospitals_and_clinics: 'Failed to load hospitals and clinics',
    health_record_updated_successfully: 'Health record updated successfully',
    health_record_added_successfully: 'Health record added successfully',
    files_uploaded_successfully: 'Files uploaded successfully',
    failed_to_upload_files: 'Failed to upload files',
    patient_information_updated_successfully: 'Patient information updated successfully',
    failed_to_update_patient_information: 'Failed to update patient information',
    note_added_successfuly_successfully: 'Note added successfuly',
    upcomming_appointment: 'Upcoming Appointments',
    temp: 'Temp',
    // temp: 'Temp',
    purchased_subscription: 'Purchased subscription',
    no_active_subscription: 'No active subscription',
    plans: 'Plans',
    expires_on: 'Expires on',
    no_plans_purchase: 'No plans purchased',
    health_alert: 'Health Alerts',
    // plans: 'Plans',
    // expires_on: 'Expires on',
    // no_plans_purchase: 'No plans purchased',
    // health_alert: 'Health Alerts',
    select_subscription_plan: 'Select subscription plan',
    subscription: 'Subscription',
    select_a_plan: 'Select a plan',
    // subscription: 'Subscription',
    // select_a_plan: 'Select a plan',
    no_plans_available: 'No plans available',
    subscribing: 'Subscribing...',
    subscribe: 'Subscribe',
    confirm: 'Confirm',
    lipid_panel: 'Lipid Panel',
    kidney_function: 'Kidney Function',
    lifestyle_metrics: 'Lifestyle Metrics',
    low: 'Low',
    high: 'High',
    processing: 'Processing...',
    years_ago: 'years ago',
    creating_ticket: 'Creating Appointment...',
    please_wait: 'Please wait',

    // Qadry
    tickets: 'Tickets',
    manage_and_track_support_appointments: 'Manage and track support appointments',
    new_ticket: 'New Ticket',
    export: 'Export',
    patient: 'Patient',
    provider: 'Provider',
    appointemnt: 'Appointment',
    type: 'Type',
    additional_notes: 'Additional notes',
    appointment_link: 'Appointment Link',
    last_updated: 'Last updated',
    created: 'Created',
    patient_id: 'Patient ID',
    previous: 'Previous',
    next: 'Next',
    high_priority: 'High priority',
    search_tickets: 'Search tickets...',
    export_tickets: 'Export tickets',
    export_format: 'Export Format',
    export_summary: 'Export Summary',
    total_records: 'Total Records',
    fields: 'Fields',
    patient_name: 'Patient Name',
    appointment_date: 'Appointment Date',
    provider_type: 'Provider Type',
    provider_name: 'Provider Name',
    priority_level: 'Priority Level',
    export_time: 'Export Time',
    cancel: 'Cancel',
    export_data: 'Export Data',
    exporting: 'Exporting...',
    attachments: 'Attachments',
    low_priority: 'Low',
    normal_priority: 'Normal',
    urgent_priority: 'Urgent',
    emergency_priority: 'Emergency',
    edit: 'Edit',
    delete: 'Delete',
    overview: 'Overview',
    comments: 'Comments',
    history: 'History',
    description: 'Description',
    medical_information: 'Medical Information',
    symptoms: 'Symptoms',
    medical_history: 'Medical History',
    no_description_provided: 'No description provided.',
    no_symptoms_provided: 'No symptoms provided.',
    no_medical_history_provided: 'No medical history provided.',
    ticket: 'Ticket',
    update: 'Update',
    patient_information: 'Patient Information',
    age: 'Age',
    gender: 'Gender',
    phone: 'Phone',
    blood_type: 'Blood Type',
    address: 'Address',
    view_full_profile: 'View Full Profile',
    appointment_details: 'Appointment Details',
    date_and_time: 'Date and Time',
    mode: 'Mode',
    join_meeting: 'Join Meeting',
    provider_information: 'Provider Information',
    add_a_comment: 'Add a comment...',
    add_comment: 'Add comment',
    no_comments_yet: 'No comments yet.',
    no_history_yet: 'No history yet.',
    add_files: 'Add files',
    no_attachments_yet: 'No attachments yet.',
    preview: 'Preview',
    delete_document: 'Delete Document',
    are_you_sure_you_want_to_delete_this_attachment:
      'Are you sure you want to delete this attachment?',
    yes: 'Yes',
    no: 'No',
    attachment_deleted_successfully: 'Attachment deleted successfully',
    failed_to_delete_attachment: 'Failed to delete attachment',
    ticket_update_successfully: 'Appointment updated successfully',
    failed_to_update_ticket: 'Failed to update Appointment',
    nothing_changed_pleaase_make_your_changes:
      'Nothing Changed, please make your changes and update.',
    failed_to_update_ticket_status: 'Failed to update appointment status',
    appointment_deleted_successfully: 'Appointment deleted successfully',
    search_appointments: 'Search appointments...',
    export_appointments: 'Export appointments',
    failed_to_delete_ticket: 'Failed to delete appointment',
    comment_added_successfully: 'Comment added successfully',
    failed_to_add_comment: 'Failed to add comment',
    file_uploaded_successfully: 'File uploaded successfully',
    failed_to_upload_file: 'Failed to upload file',
    ticket_status_updated_to: 'Appointment status updated to',
    delete_ticket: 'Delete appointment',
    are_you_sure_do_you_want_to_delete_this_ticket:
      'Are you sure you want to delete this appointment? This action cannot be undone.',
    add_medical_record: 'Add medical record',
    category: 'Category',
    record_name: 'Record name',
    doctor_name: 'Doctor name',
    date: 'Date',
    specialities: 'Specialities',
    select_specialities: 'Select specialities',
    hospital_clinic: 'Hospital/Clinic',
    select_hospital_clinic: 'Select Hospital/Clinic',
    drag_and_drop_files_here_or_click_to_select_files:
      'Drag and drop files here, or click to select files',
    selected_files: 'Selected files:',
    upload_medical_record: 'Upload medical record',
    enforce_change_password: 'Enforce change password',
    enter_your_old_password_and_new_password_twice_to_confirm:
      'Enter your old password and new password twice to confirm. Your password should be strong and easy to remember.',
    old_password: 'Old password',
    new_passwords_do_not_match: 'New passwords do not match',
    password_change_failed: 'Password change failed',
    an_unexpected_error_occured: 'An unexpected error occurred.',
    you_dont_have_permission_have_permission_to_access_this_page:
      'You do not have permission to access this page.',
    go_back: 'Go back',
    change: 'Changes:',
    no_tickets_found: 'No appointments found',
    no_chatbot_tickets_found: 'No tickets found',
    create_new_ticket: 'Create new Appointment',
    export_started: 'Export started',
    try_adjusting_your_search_or_filters: 'Try adjusting your search or filters',
    create_a_new_ticket_to_get_started: 'Create a new appointments to get started',
    subscription_created_successfully: 'Subscription created successfully',
    drag_and_drop_files_here_or: 'Drag and drop files here or',
    save_documents: 'Save Documents',
    please_select_a_resolving_reason: 'Please select a resolving reason',
    please_type_a_resolving_comment: 'Please type a resolving comment',
    browse_files: 'Browse Files',
    attatched_documnets: 'Attached Documents',
    no_previous_documnets: 'No previous documents...',
    failed_to_fetch_documents: 'Failed to fetch documents.',
    unexpeceted_error: 'Unexpected error.',
    view: 'View',
    mobile_number: 'Mobile number',
    no_mobile_provided: 'No mobile number provided.',
    enter_mobile: 'Enter mobile number',
    send_otp: 'Send OTP',
    otp: 'OTP',
    enter_otp: 'Enter OTP',
    verify: 'Verify',
    mobile_required: 'Mobile number is required',
    you_must_have_mobile_number_to_proceed: 'You must have a mobile number to proceed',
    go_to_profile_settings: 'Go to profile settings',
    mobile_number_added_successfuly: 'Mobile number added successfully',
    failed_to_add_mobile_number: 'Failed to add mobile number',
    an_error_occured_while_adding_your_mobile_number:
      'An error occurred while adding your mobile number',
    invalid_or_expired_otp: 'Invalid or expired OTP',
    an_error_occured_during_otp_verfication: 'An error occurred during OTP verification',
    failed_to_fetch_patients: 'Failed to fetch patients',
    subscription_expired: 'Subscription expired',
    expired: 'Expired',
    plan_expired: 'Plan expired',
    on: 'On',
    invalid_otp: 'Invalid OTP',
    we_sent_an_otp_to: 'We sent an OTP to',
    please_select_a_subscription_plan: 'Please select a subscription plan',
    subscription_channel: 'Subscription channel',
    verify_email_title: 'Verify your email address',
    enter_your_email: 'Enter your email',
    send_code: 'Send Code',
    email_not_registered_error: 'This email is not registered. Please sign up.',
    footer_text: '© 2024 dru | All Rights Reserved.',
    email_sent_to: 'We sent an Email to',
    verification_code: 'Verification Code',
    re_enter_password: 'Re-Enter password',
    reset_password: 'Reset Password',
    no_expert_notes_found: 'No expert notes found',
    expert_notes: 'Expert Notes',
    add_expert_note: 'Add expert note',
    last_update: 'last update',
    test_date: 'Test Date',
    test_type: 'Test Type',
    doctor_name_and_speciality: 'Doctor name & Specialty',
    doctor_name_speciality: 'Doctor name (Specialty)',
    laboratory: 'Laboratory',
    complaint: 'Complaint',
    info: 'Info:',
    user_id: 'User ID',
    status_management: 'Status Management',
    in_progress: 'In Progress',
    follow_up: 'Follow-up',
    resolved: 'Resolved',
    status_history: 'Status History',
    comments_and_notes: 'Comments & Notes',
    no_comments_to_display: 'No comments to display',
    no_history_to_display: 'No history to display',
    add_comment_placeholder: 'Add comment......',
    resolved_modal_instruction:
      'You are about to mark this appointment as resolved. Please specify how the patient inquiry was handled.',
    resolving_reason: 'Resolving Reason',
    select_reason: 'Select Reason',
    appointment_created: 'Appointment Created',
    complain_resolved: 'Complaint Resolved',
    lab_result_uploaded: 'Lab Result Uploaded',
    apply: 'Apply',
    chat_bot_new: 'New',
    chat_bot_in_progress: 'In-Progress',
    add_appointment: 'Add Appointment',
    send: 'Send',
    resolved_comment: 'Resolved Comment',
    comment: 'Comment',
    write_your_comment: 'Write your comment...',
    source: 'Source',

    // Maysara
    patients: 'Patients',
    patients_profiles: 'Patients profiles',
    search_patients: 'Search patients...',
    filters: 'Filters',
    all_patients: 'All patients',
    new_subscribers: 'New subscribers',
    with_appointments: 'With appointments',
    view_profile: 'View profile',
    email: 'Email',
    mobile: 'Mobile',
    profile_completion: 'Profile completion',
    subscrption: 'Subscription',
    actions: 'Actions',
    manage_and_monitor_patients_records: 'Manage and monitor patients records',
    filter_patients: 'Filter patients',
    sort_by: 'Sort by',
    name_ascending: 'Name (A-Z)',
    name_descending: 'Name (Z-A)',
    newest_first: 'Newest first',
    oldest_first: 'Oldest first',
    all_plans: 'All plans',
    basic_care_egypt: 'Basic care - EG',
    total_care_egypt: 'Total care - EG',
    total_care_saudi: 'Total care - SA',
    not_subscribed: 'Not subscribed',
    apply_filters: 'Apply filters',
    reset_filters: 'Reset filters',
    next_appointment: 'Next appointment',
    last_visit: 'Last visit',
    non_scheduled: 'Non-scheduled',
    no_visits_yet: 'No visits yet',
    new_appointment: 'New appointment',
    edit_profile: 'Edit profile',
    health: 'Health',
    appointments: 'Appointments',
    ai_summary: 'AI-summary',
    full_name: 'Full name',
    date_of_birth: 'Date of birth',
    marital_status: 'Marital status',
    chronic_conditions: 'Chronic conditions',
    occupation: 'Occupation',
    documents: 'Documents',
    medications: 'Medications',
    no_chronic_conditions: 'No chronic conditions.',
    not_specified: 'Not specified',
    emergency_contacts: 'Emergency contacts',
    contact_name: 'Contact name',
    relationship: 'Relationship',
    expiry_date: 'Expiry date',
    purchased_plans: 'Purchased plans',
    none_purchased: 'None purchased',
    health_trends: 'Health trends',
    add_diary: 'Add Diary',
    last: 'Last',
    months: 'Months',
    days: 'Days',
    weeks: 'Weeks',
    vital_signs: 'Vital signs',
    body_metrics: 'Body metrics',
    glucose_metrics: 'Glucose metrics',
    temprature: 'Temperature',
    no_data_available: 'No data available',
    health_records: 'Health records',
    add_record: 'Add record',
    details: 'Details',
    recorded_by: 'Recorded by',
    past_appointments: 'Past appointments',
    status: 'Status',
    clinical_notes_and_observations: 'Clinical notes and observations',
    add_mew_notes: 'Add new notes',
    title: 'Title',
    content: 'Content',
    enter_descriptive_title_for_the_note: 'Enter a descriptive title for the note',
    add_details_or_observations: 'Add details or observations',
    add_note: 'Add Note',
    not_addeed_successfully: 'Not added successfully',
    untitled_note: 'Untitled note',
    edit_note: 'Edit note',
    please_enter_note_title: 'Please enter a note title',
    add_new_note: 'Add new note',
    upload_document: 'Upload document',
    medical_documents: 'Medical documents',
    download: 'Download',
    health_metrics: 'Health metrics',
    diabetes_type: 'Diabetes type',
    diagnosis_yaer: 'Diagnosis year',
    primary_diabetes_indicators: 'Primary diabetes indicators',
    fatsing_blood_sugar: 'Fasting blood sugar',
    post_parandial_glucose: 'Post-prandial glucose',
    cardiovascular_health: 'Cardiovascular health',
    body_composition: 'Body composition',
    height: 'Height',
    bmi: 'BMI',
    metabolic_health: 'Metabolic health',
    hdl_cholesterol: 'HDL cholesterol',
    ldl_cholesterol: 'LDL cholesterol',
    triglycerides: 'Triglycerides',
    lifestyle: 'Lifestyle',
    stress_level: 'Stress level',
    risk_factors: 'Risk factors',
    smoking_status: 'Smoking status',
    alchohol_consumption: 'Alcohol consumption',
    n_a: 'N/A',
    normal_range: 'Normal range',
    medical_attention_needed: 'Medical attention needed',
    lifestyle_intervention_needed: 'Lifestyle intervention needed',
    immediate_attention_needed: 'Immediate attention needed',
    monitor_closely: 'Monitor closely',
    target_range_for_diabetes: 'Target range for diabetes',
    monitor_cardiovascular_health: 'Monitor cardiovascular health',
    check_medication_effects: 'Check medication effects',
    obesity_increased_diabetes_risk: 'Obesity - increases diabetes risk',
    overweight_monitor_closely: 'Overweight - monitor closely',
    healthy_weight_range: 'Healthy weight range',
    underweight_monitor_closely: 'Underweight - monitor closely',
    low_increases_cardiovascular_risk: 'Low - Increases cardiovascular risk',
    protective_level: 'Protective level',
    high_cardiovascular_risk_factor: 'High - Cardiovascular risk factor',
    high_common_in_diabetes: 'High - Common in diabetes',
    show_less: 'Show less',
    show_all_metrics: 'Show all metrics',
    smoker: 'Smoker',
    not_smoker: 'Non-smoker',
    diastolic: 'Diastolic',
    systolic: 'Systolic',

    //craeteTICKET
    patient_selection: 'Patient selection',
    speciality_selection: 'Speciality selection',
    review_submit: 'Review & submit',
    search_for_existing_patients: 'Search for existing patients',
    search_by_name_or_email: 'Search by name, phone or ID...',
    select_appointment_slot: 'Select appointment slot',
    choose_provider_type_browse_available_slots: 'Choose provider type and browse available slots',
    select_provider_type: 'Select provider type',
    change_provider_type: 'Change provider type',
    doctor: 'Doctor',
    nutritionist: 'Nutritionist',
    back: 'Back',
    available_slots_for: 'Available slots for',
    select_appointment_date_time_type: 'Select appointment date, time and type',
    appointment_type: 'Appointment type',
    virtual_consultation: 'Virtual consultation',
    in_person_visit: 'In-person Visit',
    provide_medical_details_and_any_relevant_documents:
      'Provide medical details and any relevant documents',
    symptoms_complaints: 'Symptoms/Complaints',
    describe_symptoms_reason_for_visit: 'Describe symptoms or reason for visit',
    any_relevant_medical_history: 'Any relevant medical history',
    current_medications: 'Current medications',
    allergies: 'Allergies',
    list_any_allergies: 'List any allergies',
    list_current_medications: 'List current medications',
    any_additional_notes: 'Any additional notes',
    important_note: 'Important note',
    ticket_creation_disclaimer:
      'By creating this appointment, you confirm that all provided information is accurate and consent to share this information with the healthcare provider.',
    create_ticket: 'Create ticket',
    review_confirmation: 'Review & Confirm',
    review_msg: 'Please review the appointment details before confirming',
    patient_selection_required: 'Patient selection is required',
    speciality_selection_required: 'Speciality and appointment date are required',
    consolation_mode: 'Consultation mode',
    initial_consultation: 'Initial consultation',
    followup_visit: 'Follow-up visit',
    urget_care: 'Urgent care',
    routine_checkup: 'Routine checkup',
    select_type: 'Select type',
    upload_files: 'Upload files',
    medical_records: 'Medical records',
    rx: 'RX',
    lab_result: 'Lab Result',
    scans: 'Scans',
    eye_report: 'Eye Report',
    others: 'Others',
    edit_patient_info: 'Edit Patient Information',
    diabetes_information: 'Diabetes Information',
    lifestyle_factors: 'Lifestyle Factors',
    pregnancy_status: 'Pregnancy Status',
    other_medical_conditions: 'Other Medical Conditions',
    select_blood_type: 'Select blood type',
    enter_chronic_conditions: 'Enter chronic conditions (separated by commas)',
    select_status: 'Select status',
    not_pregnant: 'Not Pregnant',
    pregnant: 'Pregnant',
    planning: 'Planning Pregnancy',
    select_level: 'Select level',
    none: 'None',
    heavy: 'Heavy',
    never_smoker: 'Never Smoked',
    former_smoker: 'Former Smoker',
    current_smoker: 'Current Smoker',
    select_gender: 'Select gender',
    T1: 'Type 1 Diabetes',
    T2: 'Type 2 Diabetes',
    GEST: 'Gestational Diabetes',
    PRE: 'Pre-Diabetic',
    IDKY: 'Other Specific Type',
    changed_details: 'Changed details',
    please_enter_valid_date: 'Please enter a valid date',
    note_added_successfully: 'Note added successfully',

    // Mahmoud

    // Fatma
    //LayOut
    menu: 'Menu',
    dashboard: 'Dashboard',
    calendar: 'Calendar',
    analytics: 'Analytics',
    admin: 'Admin',
    admin_dashboard: 'Admin dashboard',
    //Dashboard Page
    total_patients: 'Total Patients',
    active_tickets: 'Active Appointments',
    upcoming_appointments: 'Upcoming Appointments',
    appointments_trends: 'Appointments Trends',
    appointment_status_distribution: 'Appointment Status Distribution',
    recent_activity: 'Recent Activity',
    no_appointments_trends: 'No appointment data available',
    no_appointments_distribution: 'No appointment distribution data available',
    view_details: 'View Details',
    no_recent_tickets: 'No recent appointments found',
    invalida_date: 'Invalid date',
    not_avaliable: 'N/A',
    ticket_created_on: 'Appointment created on',
    //calendar
    has_no_permission: 'You do not have permission to access this page.',
    close: 'Close',
    virtual: 'Virtual',
    'in-person': 'In-person',
    normal: 'Normal',
    emergency: 'Emergency',
    today: 'Today',
    calendar_month: 'Month',
    calendar_week: 'Week',
    calendar_day: 'Day',
    calendar_agenda: 'Agenda',
    all_statuses: 'All statuses',
    all_types: 'All types',
    all_doctors: 'All doctors',
    calendar_sunday: 'Sun',
    calendar_monday: 'Mon',
    calendar_tuesday: 'Tue',
    calendar_wednesday: 'Wed',
    calendar_thursday: 'Thu',
    calendar_friday: 'Fri',
    calendar_saturday: 'Sat',
    //companion messages
    companion_messages: 'Companion messages',
    no_content_available: 'No content available',
    read: 'Read',
    unread: 'Unread',
    previvous: 'Previous',
    no_comopanion_messages_found: 'No companion messages found',
    send_message: 'Send Message',
    update_message: 'Update Message',
    message: 'Message',
    send_new_companion_message: 'Send new companion message',
    please_enter_message: 'Please enter a message',
    enter_your_message: 'Enter your message',
    //admin
    manage_roles_users: 'Manage users, roles, and system settings',
    total_users: 'Total Users',
    users: 'Users',
    roles: 'Roles',
    audit_logs: 'Audit Logs',
    recommendations: 'Recommendations',
    search_users: 'Search users...',
    all_roles: 'All Roles',
    active_status: 'active',
    inactive_status: 'Inactive',
    add_user: 'Add User',
    user: 'User',
    role: 'Role',
    permissions: 'Permissions',
    view_dashboard: 'View Dashboard',
    view_patients: 'View Patients',
    create_patient: 'Create Patients',
    edit_patient: 'Edit Patients',
    delete_patient: 'Delete Patients',
    view_patient_profile: 'View Patient Profile',
    view_tickets: 'View Tickets',
    edit_ticket: 'Edit Ticket',
    view_ticket_details: 'View Ticket Details',
    configure_alert_complain: 'Configure Alert Complain',
    view_appointments: 'View Appointments',
    create_appointment: 'Create Appointment',
    edit_appointment: 'Edit Appointment',
    delete_appointment: 'Delete Appointment',
    appointment: 'Appointment',
    view_appointment_details: 'View Appointment Details',
    access_admin_panel: 'Access Admin Panel',
    view_calendar: 'View Calendar',
    view_availability: 'View Availability',
    update_availability: 'Update Availability',
    view_analytics: 'View Analytics',
    view_all_users_availability: 'View All Users Availability',
    view_plan_details: 'View Plan Details',
    delete_attachment: 'Delete Attachment',
    confirm_new_password: 'Confirm New Password',
    view_users_availability: 'View Users Availability',
    select_role: 'Select a role',
    create_user: 'Create User',
    password: 'Password',
    create_new_user: 'Create New User',
    edit_user: 'Edit User',
    update_user: 'Update User',
    delete_user: 'Delete User',
    confirm_delete_user: 'Confirm Delete User',
    are_you_sure_you_want_to_delete: 'Are you sure you want to delete',
    search_audit_logs: 'Search audit logs...',
    all_actions: 'All Actions',
    timestamp: 'Timestamp',
    action: 'Action',
    performed_by: 'Performed By',
    showing: 'Showing',
    of: 'of',
    results: 'results',
    requests: 'requests',
    no_appointments_yet: 'No Appointments Yet',
    specialty: 'Specialty',
    missed: 'Missed',
    are_you_still_in_the_call: 'Are you still there on the call?',
    call_will_end_automatically_in: 'The call will end automatically in:',
    yes_still_here: 'Stay on Call',
    close_details_popup: 'Close details popup',
    read_more: 'Read More...',
    role_management: 'Role Management',
    create_role: 'Create Role',
    permissions_assigned: 'permissions assigned',
    create_new_role: 'Create New Role',
    role_name: 'Role Name',
    allow_user_to: 'Allows user to',
    update_role: 'Update Role',
    edit_role: 'Edit Role',
    this_cannot_be_undone: 'This cannot be undone',
    confirm_delete_role: 'Confirm Delete Role',
    delete_role: 'Delete Role',
    email_notification: 'Email Notifications',
    enable_email_notification: 'Enable Email Notifications',
    send_email_notifications_for_important_events:
      'Send email notifications for important system events',
    new_ticket_notification: 'New Appointment Notifications',
    notify_agents_for_new_tickets: 'Notify agents when new appointments are created',
    ticket_update_notifications: 'Appointment Update Notifications',
    notify_users_for_update_tickets: 'Notify users when their appointments are updated',
    system_alert_notifications: 'System Alert Notifications',
    recieve_notifictions_about_system_alerts:
      'Receive notifications about system alerts and important updates',
    security_settings: 'Security Settings',
    require_two_factor_authentication: 'Require Two-Factor Authentication',
    enforce_two_factor_authentication: 'Enforce two-factor authentication for all users',
    password_requirements: 'Password Requirements',
    require_strong_passwords: 'Require Strong Passwords',
    enable_password_expiration: 'Enable Password Expiration',
    password_expiration_period: 'Password Expiration Period (days)',
    automated_tasks: 'Automated Tasks',
    auto_close_inactive_tickets: 'Auto-close Inactive Appointments',
    archive_old_tickets: 'Archive Old Appointments',
    default_appointment_duration: 'Default Appointment Duration',
    save_settings: 'Save Settings',
    add_recommendation: 'Add Recommendation',
    severity_label: 'Severity',
    edit_recommendation: 'Edit Recommendation',
    create_recommendation: 'Create Recommendation',
    recommendation_name: 'Recommendation Name',
    enter_recommendation_name: 'Enter recommendation name',
    conditions: 'Conditions',
    plan_details: 'Plan Details',
    save_recommendation: 'Save Recommendation',
    condition_type: 'Condition Type',
    condition_and: 'AND (All conditions must be met)',
    condition_or: 'OR (At least one condition must be met)',
    metric_conditions: 'Metric Conditions',
    select_metric: 'Select Metric',
    metric_bmi: 'BMI',
    metric_weight: 'Weight',
    metric_blood_pressure: 'Blood Pressure',
    metric_blood_sugar: 'Blood Sugar',
    metric_heart_rate: 'Heart Rate',
    operator_greater_than: 'Greater Than',
    operator_less_than: 'Less Than',
    operator_equal_to: 'Equal To',
    operator_greater_than_or_equal: 'Greater Than or Equal',
    operator_less_than_or_equal: 'Less Than or Equal',
    value_placeholder: 'Value',
    add_condition: 'Add Condition',
    plan_title: 'Plan Title',
    enter_plan_title: 'Enter plan title',
    enter_plan_description: 'Enter plan description',
    duration: 'Duration',
    duration_placeholder: 'e.g., 3 months',
    recommended_actions: 'Recommended Actions',
    enter_recommended_action: 'Enter recommended action',
    add_action: 'Add Action',
    severity: 'Severity',
    severity_low: 'Low',
    severity_medium: 'Medium',
    severity_high: 'High',
    tags: 'Tags',
    add_tag_placeholder: 'Add tag (press Enter)',

    glucose_name: 'Glucose Management',
    glucose_management_description: 'Critical metrics for diabetes blood sugar control',
    fasting_blood_sugar_name: 'Fasting Blood Sugar',
    fasting_blood_sugar_help: 'Blood glucose level after 8+ hours of fasting',
    post_prandial_glucose_name: 'Post-Meal Blood Sugar',
    post_meal_blood_sugar_help: 'Blood glucose 2 hours after eating',
    hba1c_name: 'HbA1c (A1C)',
    hba1c_help: 'Average blood sugar over past 3 months',
    random_blood_sugar_name: 'Random Blood Sugar',
    random_blood_sugar_help: 'Blood glucose at any time of day',
    vital_name: 'Diabetes-Related Vital Signs',
    diabetes_vital_signs_description: 'Key physiological indicators for diabetes management',
    blood_pressure_name: 'Blood Pressure',
    blood_pressure_help: 'Blood pressure management for diabetes patients',
    heart_rate_name: 'Resting Heart Rate',
    resting_heart_rate_help: 'Heart rate indicator of cardiovascular health',
    ketones_name: 'Blood Ketones',
    blood_ketones_help: 'Ketone levels to detect potential diabetic ketoacidosis',
    metabolic_name: 'Metabolic Health Markers',
    metabolic_health_markers_description: 'Comprehensive metabolic indicators for diabetes',
    cholesterol_name: 'Total Cholesterol',
    total_cholesterol_help: 'Cholesterol levels crucial for diabetes patients',
    ldl_cholesterol_name: 'LDL Cholesterol',
    ldl_cholesterol_help: 'Low-density lipoprotein (bad cholesterol)',
    hdl_cholesterol_name: 'HDL Cholesterol',
    hdl_cholesterol_help: 'High-density lipoprotein (good cholesterol)',
    triglycerides_name: 'Triglycerides',
    triglycerides_help: 'Fat in the blood, important for diabetes management',
    please_fill_all_fields: 'Please fill in all required fields',
    recommendation_levels_for: 'Recommendation Levels for',
    add_level: 'Add Level',
    minimum_value: 'Minimum Value',
    maximum_value: 'Maximum Value',
    color: 'Color',
    yellow: 'Yellow',
    red: 'Red',
    green: 'Green',
    level_label: 'Level Label',
    recommendation_message_ar: 'Recommendation Message in Arabic',
    recommendation_message_en: 'Recommendation Message in English',

    add: 'Add',
    severity_color: 'Severity Color',
    remove_level: 'Remove Level',
    no_recommendation_levels: 'No recommendation levels defined. Add your first level.',
    unsaved_changes: 'Unsaved Changes',
    all_changes_saved: 'All Changes Saved',
    overall_minimum_value: 'Overall Minimum Value',
    overall_maximum_value: 'Overall Maximum Value',
    diabetes_health_metrics: 'Diabetes Health Metrics Configuration',
    define_precise_thresholds:
      'Define precise thresholds and recommendations for diabetes management',
    diabetes_metrics_configuration_guidelines: 'Diabetes Metrics Configuration Guidelines',
    metric_custom_thresholds: 'Each metric has custom thresholds tailored for diabetes management',
    recommendation_levels_diabetes:
      'Recommendation levels are specific to diabetes-related health indicators',
    color_coding_risk_levels:
      'Color coding helps quickly identify risk levels: Green (safe), Yellow (caution), Red (high risk)',
    ranges_medical_guidelines:
      'Ranges and recommendations are based on medical guidelines for diabetes care',
    customize_levels_patient_needs:
      'Customize levels to match individual patient needs and medical advice',

    failed_to_load_admin_data_notification: 'Failed to load admin data',
    update_health_metrics_notification: 'Health metrics configuration updated successfully',
    failed_to_update_health_metrics_notification: 'Failed to update health metrics configuration',
    fill_in_required_fields_notification: 'Please fill in all required fields',
    failed_to_create_user_notification: 'Failed to create user',
    success_update_user_notification: 'User updated successfully',
    failed_to_update_user: 'Failed to update user',
    user_deleted_successfully_notification: 'User deleted successfully',
    failed_to_delete_user: 'Failed to delete user',
    role_created_successfully_notification: 'Role created successfully',
    failed_to_create_role: 'Failed to create role',
    role_updated_successfully_notification: 'Role updated successfully',
    failed_to_update_role: 'Failed to update role',
    role_deleted_successfully_notification: 'Role deleted successfully',
    failed_to_delete_role: 'Failed to delete role',
    settings_updated_successfully_notification: 'Settings updated successfully',
    recommendation_updated_successfully_notification:
      'Recommendation configuration updated successfully',
    failed_to_save_recommendation: 'Failed to save recommendation configuration',
    select_chronic_conditions: 'Select Chronic Conditions',
    search_conditions: 'Search conditions',
    select_allergies: 'Select Allergies',

    health_metrics_config_updated: 'Health Metrics Config Updated',
    role_created: 'Role Created',
    role_updated: 'Role Updated',
    role_deleted: 'Role Deleted',
    ticket_created: 'Appointmet Created',
    ticket_updated: 'Appointmet Updated',
    ticket_deleted: 'Appointmet Deleted',
    comment_created: 'Comment Created',
    medical_record_created: 'Medical Record Created',
    attachment_deleted: 'Attachment Deleted',
    patient_updated: 'Patient Updated',
    patient_health_profile_updated: 'Patient Health Profile Updated',
    settings_updated: 'Settings Updated',
    region: 'Region',
    all_regions: 'All Regions',
    eg_region: 'EG',
    sa_region: 'SA',
    select_speciality: ' Select specialty',
    speciality: ' Specialty',
    failed_to_fetch_specialities: 'Failed to fetch specialities',
    expert_note: 'Expert Note',
    yesterday: 'Yesterday',
    expert_note_deleted_successfully: 'Expert note deleted successfully',
    failed_to_delete_expert_note: 'Failed to delete expert note',
    expert_note_created_successfully: 'Expert note created successfully',
    failed_to_create_expert_note: 'Failed to create expert note',
    save: 'Save',
    expert_note_is_required: 'Expert note is required',
    // Specialty Management
    specialties: 'Specialties',
    specialty_name: 'Specialty Name',
    add_specialty: 'Add Specialty',
    edit_specialty: 'Edit Specialty',
    delete_specialty: 'Delete Specialty',
    confirm_delete_specialty:
      'Are you sure you want to delete this specialty? This action cannot be undone.',
    specialty_already_exists: 'A specialty with this name already exists',
    specialty_added_successfully: 'Specialty added successfully',
    specialty_updated_successfully: 'Specialty updated successfully',
    specialty_deleted_successfully: 'Specialty deleted successfully',
    specialty_activated_successfully: 'Specialty activated successfully',
    specialty_deactivated_successfully: 'Specialty deactivated successfully',
    failed_to_load_specialties: 'Failed to load specialties',
    failed_to_add_specialty: 'Failed to add specialty',
    failed_to_update_specialty: 'Failed to update specialty',
    failed_to_delete_specialty: 'Failed to delete specialty',
    failed_to_update_specialty_status: 'Failed to update specialty status',
    search_specialties: 'Search specialties',
    no_specialties_found: 'No specialties found',
    english: 'English',
    arabic: 'Arabic',
    view_in_expert_note: 'View in Expert Note',
    no_specialities_found: 'No specialties found',
    search_speciality: 'Search specialty',
    failed_to_update_status: 'Failed to update status',
    change_status_to_waiting_for_action: 'Change status to waiting for action',
    close_ticket: 'Close Appointment',
    are_you_sure_do_you_want_to_close_this_ticket: 'Are you sure you want to complete this booking',
    first_name: 'First Name',
    last_name: 'Last Name',
    invalid_phone_number: 'Invalid phone number',
    invalid_email: 'Invalid email',
    chatbot_tickets: 'Chatbot Tickets',
    created_date: 'Created Date',
    updated_date: 'Updated Date',
    chatbot_search_placeholder: 'Search by Patient name , External ID, phone or ticket id ... ',
    lab_result_inquiry: 'Lab Result Inquiry',
    medical_appointment: 'Medical Appointment',
    chatbot_complaint: 'Complaint',
    appointment_type_required: 'Appointment type is required',
    symptoms_required: 'Symptoms are required',
    active: 'Active',
    please_enter_valid_phone_number: 'Please enter a valid phone number',
    created_at: 'Created At',
    freeTrial: 'Free trial',
    health_history: 'Health History',
    diary_name: 'diary Name',
    time: 'Time',
    reading: 'reading',
    all_diaries: 'All Diaries',
    workout: 'Workout',
    water: 'Water',
    carbohydrates: 'Carbohydrates',
    error_fetching_health_records: 'Error fetching health records',
    no_diary_entries: 'No diary entries found',
    range_of_date: 'Range of Date',
    date_from: 'Date from',
    date_to: 'Date to',
    date_from_cannot_be_after_date_to: 'Date from cannot be after date to',
    date_from_and_date_to_are_required_to_apply: 'Date from and date to are required to apply',
    min: 'min',
    hr: 'hr',
    no_historical_data_available_for_this_metric_yet:
      'No historical data available for this metric yet',
    notification_center: 'Notification Center',
    notifications_list: 'Notifications List',
    create_notification: 'Create Notification',
    total_number_of_notifications: 'Total Number of notifications',
    total_recipients: 'Total Recipients',
    recipients: 'Recipients',
    clicked: 'Clicked',
    total_scheduled: 'Total Scheduled',
    upcoming: 'Upcoming',
    search_notification_title_placeholder: 'Search Notification title...',
    all_status: 'All Status',
    sent: 'Sent',
    scheduled: 'Scheduled',
    performance: 'Performance',
    no_clicks: 'No Clicks',
    clicks: 'clicks',
    notification_view: 'Notification View',
    view_detailed_information_about_this_notification:
      'View detailed information about this notification',
    call_to_action: 'Call to Action',
    sent_date: 'Sent Date',
    sent_time: 'Sent Time',
    performance_metrics: 'Performance Metrics',
    total_clicks: 'Total Clicks',
    ctr: 'Click-Through Rate',
    notification_template_deleted_successfully: 'Notification template deleted successfully',
    failed_to_delete_notification_template: 'Failed to delete notification template',
    failed_to_export_notifications_data: 'Failed to export notifications data.',
    select_date: 'Select date',
    no_date_selected: 'No date selected',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    su: 'Su',
    mo: 'Mo',
    tu: 'Tu',
    we: 'We',
    th: 'Th',
    fr: 'Fr',
    sa: 'Sa',
    audience: 'Audience',
    notification_title: 'Notification Title',
    notifications_report: 'Notifications-Report',
    group_users: 'Group Users',
    single_users: 'Single Users',
    send_now: 'Send Now',
    schedule: 'Schedule',
    send_test: 'Send Test',

    no_notifications_yet: 'No notifications yet',
    get_started_notifications:
      'Get started by creating your first notification to engage with your users',
    continue_to_content: 'Continue to Content',
    continue_to_review: 'Continue to Review',
    select_audience: 'Select Audience',
    estimated_receipients: 'Estimated Receipients',
    user_group: 'User Group',
    search_users_hint: 'Search by name, phone, email',
    filter_by_criteria: 'Filter by criteria',
    all: 'All',
    active_7_days_ago: 'Active 7 Days Ago',
    active_14_days_ago: 'Active 14 Days Ago',
    inactive_7_days_ago: 'Inactive 7 Dyas Ago',
    inactive_14_days_ago: 'Inactive 14 Days Ago',
    inactive_30_days_ago: 'Inactive 30 days Ago',
    wellness: 'Wellness',
    weight_loss: 'Weight Loss',
    rest_of_the_world: 'Rest of the World',
    target_condition: 'Target Condition',
    user_activity: 'User Activity',
    age_group: 'Age Group',
    subscription_status: 'Subscription Status',
    egypt: 'Egypt',
    KSA: 'KSA',
    continue_to_preview: 'Continue to Preview',
    estimated_recipients: 'Estimated Recipients',
    test: 'Test',
    whitelist_management: 'Whitelist Management',
    choose_who_will_receive_the_test_notification: 'Choose who will receive the test notification',
    whitelist: 'Whitelist',
    no_users_in_whitelist: 'No users in whitelist',
    switch_to_search_users_to_add_users: 'Switch to Search Users to add users',
    no_users_exists: 'No users exists',
    try_again_with_different_search: 'Try again with different search',
    searching: 'Searching',
    added: 'Added',
    deselect_all: 'Deselect All',
    select_all: 'Select All',
    review: 'Review',
    Subscribed: 'Subscribed',
    notification_content: 'Notification Content',
    this_will_disconnect_the_video_consultation_with_the_patient:
      'This will disconnect the video consultation with the patient.',
    end_call: 'End Call',
    select_reason_for_ending_consultation: 'Select reason for ending consultation',
    this_will_cancel_the_patient_appointment:
      'This will cancel the patient appointment with the doctor, are you sure?',
    yes_cancel: 'yes, Cancel',
    no_keep_it: 'Back',
    select_reason_for_cancel_consultation: 'Select reason for cancel consultation',
    consultation_completed: 'Consultation completed',
    patient_did_not_join_the_call: 'Patient did not join the call',
    poor_internet_connection: 'Poor internet connection',
    technical_audio_issue: 'Technical/audio issue',
    emergency_interruption: 'Emergency interruption',
    patient_requested_to_end_the_session: 'Patient requested to end the session',
    submit: 'Submit',
    type_something: 'Type something',
    brief_en: 'Bio English',
    brief_ar: 'Bio Arabic',
    brief_en_placeholder: 'Write a professional Brief in English (min. 20 characters)..',
    brief_ar_placeholder: 'سيرة ذاتية قصيرة أو معلومات مهنية عن الطبيب...',
    brief_min_length_error: 'The brief must be at least 20 characters long.',
    characters_counter: 'characters',

    // Complain alerts configuration
    configure_complain_alerts: 'Configure Complain alerts',
    configure_complain_alerts_subtitle: 'Choose when to notify your team about Complains tickets.',
    notify_on_new_ticket_creation: 'Notify on New Ticket creation',
    notify_on_new_ticket_creation_hint: 'Send an email immediately when a patient opens a ticket.',
    notify_when_there_is_no_response: 'Notify when there is No Response',
    notify_when_there_is_no_response_hint:
      "Send automated alerts if an agent hasn't replied within a set time.",
    recipient_emails_type_and_press_enter: 'Recipient Emails (Type & press Enter)',
    no_response_schedule_actions: 'No Response Schedule (Actions)',
    send_email_to: 'Send Email to:',
    send_email_after: 'Send email after',
    hour_s: 'Hour(s)',
    add_another_reminder_timer: 'Add Another Reminder Timer',
    remove_reminder_timer: 'Remove reminder timer',
    email_example_placeholder: 'e.g agent@dru-app.com',
    add_another_email_placeholder: 'add another...',
    please_enter_a_valid_email_format: 'Please enter a valid email format',
    failed_to_save_alert_settings: 'Failed to save the alert settings',

    // Add diary drawer
    add_health_record: 'Add Health Record',
    update_vitals_and_metrics: 'Update vitals and metrics',
    what_to_log: 'What would you like to log?',
    what_to_log_hint:
      'Select a category to log new health Record or manage Medications for this patient.',
    patient_diary: 'Patient Diary',
    patient_diary_hint: 'Health and Lifestyle',
    patient_medication: 'Patient Medication',
    patient_medication_hint: 'Manage medications, set dosages, and schedule reminders.',
    coming_soon: 'Coming soon',
    diary: 'Diary',
    diary_hint:
      'You can select one or more reading from the options below to update the patient diary.',
    waist: 'Waist',
    life_style: 'Life Style',
    record_selected: 'Record Selected',
    add_logs: 'Add Logs',
    done: 'Done',
    save_record: 'Save Record',
    undo: 'undo',
    record_added_successfully: 'Record added successfully',
    // Medication setup (doctor-logged prescriptions and doses)
    list_of_all_medications: 'List of all Medications',
    add_new_medication: 'Add New Medication',
    medication_details: 'Medication Details',
    medication_name: 'Medication Name',
    choose_medication: 'Choose medication',
    no_medications_add_new: 'There Is No Medication, You Can Add A New Medication.',
    no_medications_found: 'No medications found',
    search_medication: 'Search for a medication',
    clear_selection: 'Clear selection',
    how_many_times_per_day: 'How many times per day',
    forever: 'Forever',
    specific_number_of_days: 'Specific number of days',
    reminders: 'Reminders',
    reminder: 'Reminder',
    add_to_list: 'Add to list',
    dosage: 'Dosage',
    select_more_than_one: 'you can Select more than one',
    medication_added_successfully: 'Medication added Successfully',
    dosage_added_successfully: 'Dosage added Successfully',
    err_select_medication: 'Select a medication first',
    err_field_required: 'this field is required',
    err_duration: 'Duration must be at least one day',
    err_reminder_required: 'Every reminder needs a time',
    err_save_medication: 'Failed to save the medication',
    err_dose_required: 'Enter a dosage, date and time',
    err_save_dose: 'Failed to save the dosage',
    err_load_medications: 'Failed to load the medications',
    value: 'Value',
    duration_hours: 'Hours',
    duration_minutes: 'Minutes',
    types: 'Types',
    intensity: 'Intensity',
    notes_placeholder: 'Add a note about this reading',
    select_tags: 'Select tags',
    select_meal: 'Select a meal',
    select_intensity: 'Select intensity',
    select_amount: 'Select an amount',
    add_image: 'Add Image',
    click_to_upload_image: 'Click to upload image',
    image_hint: 'PNG, JPG up to 2MB',
    image_type_error: 'Only PNG or JPG images are accepted',
    image_size_error: 'The image must be 2MB or smaller',
    remove_image: 'Remove image',
    delete_metric: 'Remove this metric',
    err_value_required: 'Enter a value',
    err_value_positive: 'Value must be greater than zero',
    err_value_max: 'Value is out of the accepted range',
    err_bp_format: 'Use the systolic/diastolic format, e.g. 120/80',
    err_bp_order: 'Diastolic must be lower than systolic',
    err_duration_required: 'Enter a duration',
    err_minutes_range: 'Minutes must be below 60',
    err_portion_required: 'Select an amount',
    err_date_required: 'Select a date and time',
    undo_success: 'The record was not saved',
    undo_failed: 'Could not undo the record. Save again to overwrite it.',
    steps: 'Steps',
    steps_unit: 'Steps',
    there_is_no_readings: 'There is no readings',
    upload_doc_to_plan: 'Upload document to plan',
    medication_unavailable: 'Medication unavailable',
    view_medications: 'View Medications',
    add_medication: 'Add Medication',
    delete_medication: 'Delete Medication',
    view_reminders: 'View Reminders',
    ticket_deleted_successfully: 'Appointment deleted successfully',
    consultation_mode: 'Consultation mode',
    urgent_care: 'Urgent care',
    subscribed: 'Subscribed',
    unsubscribed: 'Unsubscribed',
    view_notification_center: 'View Notification Center',
  },

  ar: {
    // Hosny
    basic_information: 'المعلومات الأساسية',
    name: 'الاسم',
    notes: 'ملاحظات',
    change_password: 'تغيير كلمة المرور',
    current_password: 'كلمة المرور الحالية',
    new_password: 'كلمة المرور الجديدة',
    confirm_new_password: 'تأكيد كلمة المرور',
    uppercase_letter: 'حرف كبير',
    lowercase_letter: 'حرف صغير',
    at_least_one_number: 'على الأقل رقم واحد',
    special_character: 'رمز خاص',
    eight_character_minimum_length: 'على الأقل 8 أحرف',
    update_password: 'تحديث كلمة المرور',
    profile: 'الملف الشخصي',
    availability: 'التوفر',
    security: 'الأمان',
    settings: 'الإعدادات',
    availability_settings: 'إعدادات التوفر',
    working_hours: 'ساعات العمل',
    break_time: 'وقت الاستراحة',
    busy_dates: 'تواريخ مشغولة',
    monday: 'الإثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    sunday: 'الأحد',
    to: 'إلى',
    save_changes: 'حفظ التغييرات',
    save_availability: 'حفظ التوفر',
    failed_to_update_profile: 'فشل تحديث الملف الشخصي',
    failed_to_update_password: 'فشل تحديث كلمة المرور',
    failed_to_update_availability: 'فشل تحديث التوفر',
    failed_to_update_settings: 'فشل تحديث الإعدادات',
    availability_updated_successfully: 'تم تحديث التوفر بنجاح',
    profile_updated_successfully: 'تم تحديث الملف الشخصي بنجاح',
    password_updated_successfully: 'تم تحديث كلمة المرور بنجاح',
    settings_updated_successfully: 'تم تحديث الإعدادات بنجاح',
    new_password_dont_match: 'كلمات المرور الجديدة لا تتطابق',
    incorrect_username_or_password: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    loading: 'جار التحميل...',
    access_denied: 'تم رفض الوصول',
    you_do_not_have_permission_to_access_this_page: 'ليس لديك إذن للوصول إلى هذه الصفحة',
    analytics_dashboard: 'لوحة تحكم التحليلات',
    all_providers: 'جميع مقدمي الخدمة',
    daily: 'يومي',
    weekly: 'أسبوعي',
    monthly: 'شهري',
    day: 'يوم',
    week: 'أسبوع',
    month: 'شهر',
    total_tickets: 'إجمالي المواعيد',
    total: 'إجمالي',
    completed_tickets: 'المواعيد المكتملة',
    completion_rate: 'معدل الإنجاز',
    avg_response_time: 'متوسط وقت الاستجابة',
    m: 'د',
    average_time_to_first_response: 'متوسط الوقت للرد الأول',
    tickets_by_status: 'المواعيد حسب الحالة',
    appointments_by_status: 'المواعيد حسب الحالة',
    appointment_distribution: 'توزيع المواعيد',
    ticket_timeline: 'جدول زمني للمواعيد',
    patient_demographics: 'التركيبة السكانية للمرضى',
    gender_distribution: 'توزيع الجنس',
    male: 'ذكر',
    female: 'أنثى',
    age_groups: 'الفئات العمرية',
    count: 'العدد',
    performance_summary: 'ملخص الأداء',
    average_response_time: 'متوسط وقت الاستجابة',
    minutes: 'دقائق',
    minute: 'دقيقة',
    date_range_summary: 'ملخص نطاق التاريخ',
    time_period: 'فترة زمنية',
    total_days: 'إجمالي الأيام',
    grouping: 'التجميع',
    completed: 'مكتمل',
    pending: 'معلق',
    'in-progress': 'قيد التنفيذ',
    cancelled: 'ملغاة',
    un_known: 'غير معروف',
    unknown: 'غير معروف',
    initial: 'أولي',
    followup: 'متابعة',
    routine: 'روتيني',
    urgent: 'عاجل',
    profile_settings: 'إعدادات الملف الشخصي',
    adim_dashboard: 'لوحة تحكم المسؤول',
    sign_out: 'تسجيل الخروج',
    open_user_menu: 'فتح قائمة المستخدم',
    notifications: 'الإشعارات',
    change_language: 'تغيير اللغة',
    contextual_insights: 'الرؤى السياقية',
    total_appointments: 'إجمالي المواعيد',
    recent_health_records: 'السجلات الصحية الأخيرة',
    last_check_up: 'آخر فحص',
    click_regerate: 'اضغط على "توليد الرؤى" للحصول على تحليل صحي مدعوم بالذكاء الاصطناعي',
    blood_sugar: 'مستوى السكر في الدم',
    heart_rate: 'معدل ضربات القلب',
    weight: 'الوزن',
    blood_pressure: 'ضغط الدم',
    key_health_metrics: 'المقاييس الصحية الرئيسية',
    ai_clinical_insights: 'الرؤى السريرية المدعومة بالذكاء الاصطناعي',
    moderate_health_risk: 'خطر صحي معتدل',
    overall_health_risk_score: 'درجة الخطر الصحي العامة',
    generating: 'جارٍ التوليد...',
    regenerate_insights: 'إعادة توليد الرؤى',
    generate_insights: 'توليد الرؤى',
    no_recent_records: 'لا توجد سجلات حديثة',
    comprehensive_health_narrative: 'السرد الصحي الشامل',
    low_risk: 'خطر منخفض',
    high_risk: 'خطر مرتفع',
    moderate_risk: 'خطر معتدل',
    mmHg: 'mmHg',
    bpm: 'bpm',
    mg_dL: 'mg/dL',
    kg: 'كيلو جرام',
    g: 'جرام',
    L: 'لتر',
    edit_health_record: 'تعديل السجل الصحي',
    new_health_record: 'سجل صحي جديد',
    temperature: 'درجة الحرارة',
    fasting_insulin: 'الأنسولين الصائم',
    hba1c: 'السكر التراكمي',
    post_prandial_glucose: 'الجلوكوز بعد الوجبة',
    hdl: 'HDL',
    ldl: 'LDL',
    microalbumin: 'الميكروألبومين',
    egfr: 'EGFR',
    carbIntake: 'الكربوهيدرات المستهلكة',
    water_intake: 'تناول الماء',
    diet_type: 'نوع النظام الغذائي',
    exercise_minutes: 'دقائق التمارين',
    daily_steps: 'خطوات يومية',
    sleep_hours: 'ساعات النوم',
    medication: 'الأدوية',
    no_changes_detected_in_health_metrics: 'لا توجد تغييرات ملحوظة في المقاييس الصحية',
    failed_to_update_health_metrics: 'فشل تحديث المقاييس الصحية',
    quick_add_health_record: 'إضافة سجل صحي سريع',
    or: 'أو',
    vitals: 'العلامات الحيوية',
    diabetes: 'السكر',
    cardiovascular: 'القلب والأوعية الدموية',
    kidney: 'الكلى',
    c: '°C',
    cm: 'cm',
    BMI: 'BMI',
    calculated: 'محسوب',
    fasting_blood_sugar: 'مستوى السكر في الدم الصائم',
    mui: 'µIU/mL',
    mg_L: 'mg/L',
    eGFR: 'eGFR',
    units: 'mL/min/1.73m²',
    exercise_frequency: 'تكرار التمارين',
    select_exercise_frequency: 'اختر تكرار التمارين',
    sedentary: 'خامل (قليل أو لا يوجد تمارين)',
    light: 'خفيف (1-3 أيام/الأسبوع)',
    moderate: 'معتدل (3-5 أيام/الأسبوع)',
    active_exercise: 'نشط (6-7 أيام/الأسبوع)',
    very_active: 'نشط جداً (عدة مرات يومياً)',
    select_diet_type: 'اختر نوع النظام الغذائي',
    balanced_diet: 'نظام غذائي متوازن',
    vegetarian: 'نباتي',
    vegan: 'نباتي صارم',
    ketogenic: 'كيتو',
    mediterranean: 'المتوسطي',
    paleo: 'باليو',
    other: 'آخر',
    stress_level1_10: 'مستوى التوتر (1-10)',
    record_type: 'نوع السجل',
    follow_up_visit: 'زيارة متابعة',
    specialist_consultation: 'استشارة أخصائي',
    emergency_visit: 'زيارة طارئة',
    lab_results: 'نتائج المختبر',
    telemedicine_visit: 'زيارة عن بُعد',
    current_symptoms: 'الأعراض الحالية',
    clinical_notes: 'الملاحظات السريرية',
    required_fields: 'الحقول المطلوبة:',
    saving: 'جارٍ الحفظ...',
    update_record: 'تحديث السجل',
    rate_your_stress_level: 'قيم مستوى توترك',
    describe_any_current_symptoms_or_complaincts: 'وصف أي أعراض أو شكاوى حالية...',
    list_all_current_medications_and_dosages: 'قائمة بجميع الأدوية الحالية والجرعات...',
    add_any_clinical_observations_treatment_plans_or_follow_up_recommendations:
      'إضافة أي ملاحظات سريرية، خطط علاجية، أو توصيات للمتابعة...',
    export_patients: 'تحميل ملف المرضى',
    added_filters: 'تصفية المرضى',
    export_patient_feilds: 'الحقول: المعلومات الأساسية، الاسم، الرقم، البريد الإلكتروني',
    failed_to_load_patient_data: 'فشل تحميل بيانات المرضى',
    failed_to_load_provider: 'فشل تحميل مقدمي الخدمة',
    failed_to_search_patients: 'فشل البحث عن المرضى',
    failed_to_check_provider_avaialability: 'فشل التحقق من توفر مقدمي الخدمة',
    appointment_created_successfully: 'موعد تم إنشاؤه بنجاح',
    failed_to_create_meeting_link: 'فشل إنشاء رابط الاجتماع',
    couldn_t_create_ticket: 'تعذر إنشاء الموعد',
    no_permission_to_update_ticket: 'ليس لديك إذن لتحديث التذكرة',
    active_profile: 'نشط',
    inactive_profile: 'غير نشط',
    upcomming_appointment: 'المواعيد القادمة',
    date_time: 'التاريخ والوقت',
    join_call: 'انضم إلى المكالمة',
    cancel_appointment: 'إلغاء الموعد',
    by: 'بواسطة',
    failed_to_load_hospitals_and_clinics: 'فشل تحميل المستشفيات والعيادات',
    health_record_updated_successfully: 'تم تحديث السجل الصحي بنجاح',
    health_record_added_successfully: 'تم إضافة السجل الصحي بنجاح',
    files_uploaded_successfully: 'تم تحميل الملفات بنجاح',
    failed_to_upload_files: 'فشل تحميل الملفات',
    patient_information_updated_successfully: 'تم تحديث معلومات المريض بنجاح',
    failed_to_update_patient_information: 'فشل تحديث معلومات المريض',
    note_added_successfuly_successfully: 'تم إضافة الملاحظة بنجاح',
    temp: 'درجة الحرارة',
    purchased_subscription: 'الاشتراك النشط',
    no_active_subscription: 'لا يوجد اشتراك نشط',
    plans: 'الخطط',
    expires_on: 'ينتهي في',
    no_plans_purchase: 'لا توجد خطط مفعلة',
    health_alert: 'تنبيه صحي',
    select_subscription_plan: 'اختر خطة الاشتراك',
    subscription: 'الاشتراك',
    select_a_plan: 'اختر خطة',
    no_plans_available: 'لا توجد خطط متاحة',
    subscribing: 'جارٍ الاشتراك...',
    subscribe: 'اشتراك',
    confirm: 'تأكيد',
    lipid_panel: 'لوحة الدهون',
    kidney_function: 'وظيفة الكلى',
    lifestyle_metrics: ' نماذج نمط الحياة',
    low: 'منخفض',
    high: 'مرتفع',
    processing: 'جارٍ المعالجة...',
    years_ago: 'منذ سنوات',
    creating_ticket: 'جارٍ إنشاء الموعد...',
    please_wait: 'يرجى الانتظار...',
    smoker: 'مدخن',
    not_smoker: 'غير مدخن',

    // Qadry
    symptoms: 'الأعراض',
    laboratory: 'المختبر',
    complaint: 'الشكوى',
    info: 'المعلومات:',
    user_id: 'معرف المستخدم',
    last_updated: 'آخر تحديث',
    test_date: 'تاريخ الاختبار',
    test_type: 'نوع الاختبار',
    status_management: 'إدارة الحالة',
    in_progress: 'قيد التنفيذ',
    follow_up: 'المتابعة',
    resolved: 'تم الحل',
    status_history: 'تاريخ الحالة',
    comments_and_notes: 'التعليقات والملاحظات',
    no_comments_to_display: 'لا توجد تعليقات لعرضها',
    add_comment_placeholder: 'أضف تعليق......',
    resolved_modal_instruction:
      'أنت على وشك تحديد هذا التذكرة كـ محلولة. يرجى تحديد كيفية معالجة استفسار المريض.',
    resolving_reason: 'سبب الحل',
    select_reason: 'اختر السبب',
    appointment_created: 'تم إنشاء الموعد',
    complain_resolved: 'تم حل الشكوى',
    lab_result_uploaded: 'تم رفع نتيجة المختبر',
    no_history_to_display: 'لا توجد تاريخ لعرضه',
    chat_bot_new: 'جديد',
    chat_bot_in_progress: 'قيد التنفيذ',
    add_appointment: 'إضافة موعد',
    apply: 'تطبيق',
    send: 'إرسال',
    resolved_comment: 'تعليق حل المشكلة',
    comment: 'تعليق',
    write_your_comment: 'اكتب تعليقك هنا...',
    source: 'المصدر',
    tickets: 'المواعيد',
    manage_and_track_support_appointments: 'إدارة مواعيد الدعم وتتبعها',
    search_appointments: 'البحث في المواعيد...',
    new_ticket: 'موعد جديد',
    export: 'تحميل ملف',
    patient: 'المريض',
    provider: 'مزود الخدمة',
    appointemnt: 'الموعد',
    type: 'النوع',
    additional_notes: 'ملاحظات إضافية',
    appointment_link: 'رابط الموعد',
    created: 'تاريخ الإنشاء',
    patient_id: 'معرف المريض',
    previous: 'السابق',
    next: 'التالي',
    high_priority: 'أولوية عالية',
    search_tickets: 'البحث في المواعيد...',
    export_tickets: 'تصدير المواعيد',
    export_format: 'تنسيق الملف ',
    export_summary: 'ملخص الملف',
    total_records: 'إجمالي السجلات',
    fields: 'الحقول',
    patient_name: 'اسم المريض',
    appointment_date: 'تاريخ الموعد',
    provider_type: 'نوع مزود الخدمة',
    provider_name: 'اسم مزود الخدمة',
    priority_level: 'مستوى الأولوية',
    export_time: 'وقت التصدير',
    cancel: 'إلغاء',
    export_data: 'تصدير البيانات',
    exporting: 'جارٍ التصدير...',
    attachments: 'المرفقات',
    low_priority: 'منخفض',
    normal_priority: 'عادي',
    urgent_priority: 'عاجل',
    emergency_priority: 'طارئ',
    edit: 'تعديل',
    delete: 'حذف',
    overview: 'نظرة عامة',
    comments: 'تعليقات',
    history: 'التاريخ',
    description: 'الوصف',
    medical_information: 'المعلومات الطبية',
    medical_history: 'التاريخ الطبي',
    no_description_provided: '.لا يوجد وصف مقدم',
    no_symptoms_provided: '.لا توجد أعراض مقدمة',
    no_medical_history_provided: '.لا يوجد تاريخ طبي مقدم',
    ticket: 'موعد',
    update: 'تحديث',
    patient_information: 'معلومات المريض',
    age: 'العمر',
    gender: 'الجنس',
    phone: 'الهاتف',
    blood_type: 'فصيلة الدم',
    address: 'العنوان',
    view_full_profile: 'عرض الملف الشخصي بالكامل',
    appointment_details: 'تفاصيل الموعد',
    date_and_time: 'التاريخ والوقت',
    mode: 'الوضع',
    join_meeting: 'الانضمام إلى الاجتماع',
    provider_information: 'معلومات مزود الخدمة',
    add_a_comment: '...اضف تعليقا',
    add_comment: 'إضافة تعليق',
    no_comments_yet: '.لا توجد تعليقات حتى الآن',
    no_history_yet: '.لا يوجد تاريخ حتى الآن',
    add_files: 'إضافة ملفات',
    no_attachments_yet: '.لا توجد مرفقات حتى الآن',
    preview: 'معاينة',
    delete_document: 'حذف المستند',
    are_you_sure_you_want_to_delete_this_attachment: 'هل أنت متأكد أنك تريد حذف هذا المرفق؟',
    yes: 'نعم',
    no: 'لا',
    attachment_deleted_successfully: '.تم حذف المرفق بنجاح',
    failed_to_delete_attachment: '.فشل حذف المرفق',
    ticket_update_successfully: '.تم تحديث الموعد بنجاح',
    failed_to_update_ticket: '.فشل تحديث الموعد',
    nothing_changed_pleaase_make_your_changes: '.لم يتغير شيء، يرجى إجراء تغييراتك وتحديثها',
    failed_to_update_ticket_status: '.فشل تحديث حالة الموعد',
    ticket_deleted_successfully: '.تم حذف الموعد بنجاح',
    failed_to_delete_ticket: '.فشل حذف الموعد',
    comment_added_successfully: 'تم إضافة التعليق بنجاح',
    failed_to_add_comment: 'فشل إضافة التعليق',
    file_uploaded_successfully: 'تم تحميل الملف بنجاح',
    failed_to_upload_file: 'فشل تحميل الملف',
    ticket_status_updated_to: 'تم تحديث حالة الموعد إلى',
    delete_ticket: 'حذف الموعد',
    are_you_sure_do_you_want_to_delete_this_ticket:
      'هل أنت متأكد أنك تريد حذف هذا الموعد؟ لا يمكن التراجع عن هذا الإجراء.',
    add_medical_record: 'إضافة سجل طبي',
    category: 'الفئة',
    record_name: 'اسم السجل',
    doctor_name: 'اسم الطبيب',
    date: 'التاريخ',
    specialities: 'التخصصات',
    select_specialities: 'اختر التخصصات',
    hospital_clinic: 'المستشفى / العيادة',
    select_hospital_clinic: 'اختر المستشفى / العيادة',
    drag_and_drop_files_here_or_click_to_select_files:
      'اسحب وأفلت الملفات هنا أو انقر لاختيار الملفات',
    selected_files: ':الملفات المحددة',
    upload_medical_record: 'تحميل السجل الطبي',
    enforce_change_password: 'فرض تغيير كلمة المرور',
    enter_your_old_password_and_new_password_twice_to_confirm:
      '.أدخل كلمة المرور القديمة وكلمة المرور الجديدة مرتين للتأكيد. يجب أن تكون كلمة المرور قوية وسهلة التذكر',
    old_password: 'كلمة المرور القديمة',
    new_passwords_do_not_match: 'كلمات المرور الجديدة لا تتطابق',
    password_change_failed: 'فشل تغيير كلمة المرور',
    an_unexpected_error_occured: 'حدث خطأ غير متوقع.',
    you_dont_have_permission_have_permission_to_access_this_page:
      '.ليس لديك إذن للوصول إلى هذه الصفحة',
    go_back: 'العودة',
    change: ':التغييرات',
    no_tickets_found: 'لا توجد مواعيد',
    no_chatbot_tickets_found: 'لا توجد تذاكر',
    create_new_ticket: 'إنشاء موعد جديد',
    export_started: 'بدأ التصدير',
    try_adjusting_your_search_or_filters: 'حاول ضبط بحثك',
    create_a_new_ticket_to_get_started: 'إنشاء موعد جديد للبدء',
    drag_and_drop_files_here_or: 'اسحب وأفلت الملفات هنا أو',
    save_documents: 'حفظ المستندات',
    browse_files: 'تصفح الملفات',
    attatched_documnets: 'المستندات المرفقة',
    no_previous_documnets: 'لا توجد مستندات سابقة...',
    failed_to_fetch_documents: 'فشل جلب المستندات',
    unexpeceted_error: 'خطأ غير متوقع',
    view: 'عرض',
    mobile_number: 'رقم الهاتف',
    no_mobile_provided: 'لا يوجد رقم هاتف مقدم',
    enter_mobile: 'أدخل رقم الهاتف',
    send_otp: 'إرسال الرقم السري المتغير',
    otp: 'الرقم السري المتغير',
    enter_otp: 'أدخل الرقم السري المتغير',
    verify: 'تحقق',
    mobile_required: 'رقم الهاتف مطلوب',
    you_must_have_mobile_number_to_proceed: 'يجب أن يكون لديك رقم هاتف للمتابعة',
    go_to_profile_settings: 'اذهب إلى إعدادات الملف الشخصي',
    mobile_number_added_successfuly: 'تم إضافة رقم الهاتف بنجاح',
    failed_to_add_mobile_number: 'فشل إضافة رقم الهاتف',
    an_error_occured_while_adding_your_mobile_number: 'حدث خطأ أثناء إضافة رقم هاتفك',
    invalid_or_expired_otp: 'الرقم السري المتغير غير صالح أو منتهي الصلاحية',
    an_error_occured_during_otp_verfication: 'حدث خطأ أثناء التحقق من الرقم السري المتغير',
    failed_to_fetch_patients: 'فشل جلب المرضى',
    subscription_expired: 'انتهت صلاحية الاشتراك',
    on: 'في',
    expired: 'انتهى',
    plan_expired: 'انتهت صلاحية الخطة',
    invalid_otp: 'الرقم السري المتغير غير صالح',
    we_sent_an_otp_to: 'أرسلنا الرقم السري المتغير إلى',
    please_select_a_subscription_plan: 'يرجى اختيار خطة اشتراك',
    subscription_channel: 'طريقة الاشتراك',
    verify_email_title: 'تحقق من عنوان بريدك الإلكتروني',
    enter_your_email: 'أدخل بريدك الإلكتروني',
    send_code: 'إرسال الرمز',
    email_not_registered_error: 'هذا البريد الإلكتروني غير مسجل. الرجاء التسجيل أولاً.',
    footer_text: '© 2024 dru | جميع الحقوق محفوظة.',
    email_sent_to: 'أرسلنا بريدًا إلكترونيًا إلى',
    verification_code: 'رمز التحقق',
    re_enter_password: 'أعد إدخال كلمة المرور',
    reset_password: 'إعادة تعيين كلمة المرور',
    no_expert_notes_found: 'لم يتم العثور على ملاحظات الخبراء',
    expert_notes: 'ملاحظات الخبراء',
    add_expert_note: 'إضافة ملاحظات الخبراء',
    last_update: 'آخر تحديث',
    doctor_name_and_speciality: 'اسم الطبيب والتخصص',
    doctor_name_speciality: 'اسم الطبيب (التخصص)',

    // Maysara
    patients: 'المرضى',
    patients_profiles: 'ملفات المرضى',
    search_patients: '...بحث عن المرضى',
    filters: 'الخيارات',
    all_patients: 'جميع المرضى',
    new_subscribers: 'مشتركون جدد',
    with_appointments: 'بمواعيد',
    view_profile: 'عرض الملف الشخصي',
    email: 'البريد الإلكتروني',
    mobile: 'رقم الهاتف',
    profile_completion: 'اكتمال الملف الشخصي',
    subscrption: 'الاشتراك',
    actions: 'الإجراءات',
    manage_and_monitor_patients_records: 'إدارة ومراقبة سجلات المرضى',
    filter_patients: 'تصفية المرضى',
    sort_by: 'ترتيب حسب',
    name_ascending: 'الاسم (أ-ي)',
    name_descending: 'الاسم (ي-أ)',
    newest_first: 'الأحدث أولاً',
    oldest_first: 'الأقدم أولاً',
    all_plans: 'جميع الخطط',
    basic_care_egypt: 'الرعاية الأساسية - مصر',
    total_care_egypt: 'الرعاية الكاملة - مصر',
    total_care_saudi: 'الرعاية الكاملة - السعودية',
    not_subscribed: 'غير مشترك',
    apply_filters: 'تطبيق الالخيارات',
    reset_filters: 'إعادة تعيين الالخيارات',
    next_appointment: 'الموعد التالي',
    last_visit: 'المواعيد السابقة',
    non_scheduled: 'غير مجدول',
    no_visits_yet: 'لا توجد زيارات حتى الآن',
    new_appointment: 'موعد جديد',
    edit_profile: 'تعديل الملف الشخصي',
    health: 'الصحة',
    appointments: 'المواعيد',
    ai_summary: 'ملخص الذكاء الاصطناعي',
    full_name: 'الاسم الكامل',
    date_of_birth: 'تاريخ الميلاد',
    marital_status: 'الحالة الاجتماعية',
    chronic_conditions: 'الحالات المزمنة',
    occupation: 'الوظيفة',
    documents: 'الملفات',
    medications: 'الأدوية',
    no_chronic_conditions: 'لا توجد حالات مزمنة.',
    not_specified: 'غير محدد',
    emergency_contacts: 'جهات الاتصال في حالات الطوارئ',
    contact_name: 'اسم جهة الاتصال',
    relationship: 'العلاقة',
    expiry_date: 'تاريخ الانتهاء',
    purchased_plans: 'الخطط المفعلة',
    none_purchased: 'لا توجد خطط مفعلة',
    health_trends: 'مؤشرات الصحة',
    add_diary: 'إضافة يوميات',
    last: 'آخر',
    months: 'أشهر',
    days: 'أيام',
    weeks: 'أسابيع',
    vital_signs: 'العلامات الحيوية',
    body_metrics: 'مقاييس الجسم',
    glucose_metrics: 'مقاييس الجلوكوز',
    temprature: 'درجة الحرارة',
    no_data_available: 'لا توجد بيانات متاحة',
    health_records: 'السجلات الصحية',
    add_record: 'إضافة سجل',
    details: 'تفاصيل',
    recorded_by: 'تم التسجيل بواسطة',
    past_appointments: 'المواعيد السابقة',
    status: 'الحالة',
    clinical_notes_and_observations: 'الملاحظات السريرية والمشاهدات',
    add_mew_notes: 'إضافة ملاحظات جديدة',
    title: 'العنوان',
    content: 'المحتوى',
    enter_descriptive_title_for_the_note: 'أدخل عنوانًا وصفيًا للملاحظة',
    add_details_or_observations: 'أضف تفاصيل أو ملاحظات',
    add_note: 'إضافة ملاحظة',
    not_addeed_successfully: 'لم تتم الإضافة بنجاح',
    untitled_note: 'ملاحظة بدون عنوان',
    edit_note: 'تعديل الملاحظة',
    please_enter_note_title: 'يرجى إدخال عنوان الملاحظة',
    add_new_note: 'إضافة ملاحظة جديدة',
    download: 'تحميل',
    upload_document: 'تحميل مستند',
    medical_documents: 'المستندات الطبية',
    health_metrics: 'مقاييس الصحة',
    diabetes_type: 'نوع السكر',
    diagnosis_yaer: 'سنة التشخيص',
    primary_diabetes_indicators: 'المؤشرات الرئيسية للسكري',
    fatsing_blood_sugar: 'سكر الدم الصائم',
    post_parandial_glucose: 'سكر الدم بعد الأكل',
    cardiovascular_health: 'صحة القلب والأوعية الدموية',
    body_composition: 'تركيب الجسم',
    height: 'الطول',
    bmi: 'مؤشر كتلة الجسم',
    metabolic_health: 'الصحة الأيضية',
    hdl_cholesterol: 'الكوليسترول الجيد (HDL)',
    ldl_cholesterol: 'الكوليسترول الضار (LDL)',
    triglycerides: 'الدهون الثلاثية',
    lifestyle: 'نمط الحياة',
    stress_level: 'مستوى التوتر',
    risk_factors: 'عوامل الخطر',
    smoking_status: 'حالة التدخين',
    alchohol_consumption: 'استهلاك الكحول',
    n_a: 'غير متاح',
    normal_range: 'النطاق الطبيعي',
    medical_attention_needed: 'يتطلب رعاية طبية',
    lifestyle_intervention_needed: 'يتطلب تدخلًا في نمط الحياة',
    immediate_attention_needed: 'يتطلب اهتمامًا فوريًا',
    monitor_closely: 'يجب المراقبة عن كثب',
    target_range_for_diabetes: 'النطاق المستهدف لمرض السكر',
    monitor_cardiovascular_health: 'مراقبة صحة القلب والأوعية الدموية',
    check_medication_effects: 'التحقق من تأثير الأدوية',
    obesity_increased_diabetes_risk: 'السمنة تزيد من خطر الإصابة بالسكر',
    overweight_monitor_closely: 'زيادة في الوزن، يجب المراقبة عن كثب',
    healthy_weight_range: 'نطاق الوزن الصحي',
    underweight_monitor_closely: 'نقص الوزن، يجب المراقبة عن كثب',
    low_increases_cardiovascular_risk: 'منخفض - يزيد من خطر أمراض القلب والأوعية الدموية',
    protective_level: 'مستوى وقائي',
    high_cardiovascular_risk_factor: 'مرتفع - عامل خطر لأمراض القلب والأوعية الدموية',
    high_common_in_diabetes: 'مرتفع - شائع في حالات السكر',
    show_less: 'عرض أقل',
    show_all_metrics: 'عرض جميع المقاييس',
    patient_selection: 'اختيار المريض',
    speciality_selection: 'اختيار الاختصاص',
    review_submit: 'مراجعة وتقديم',
    search_for_existing_patients: 'البحث عن المرضى الموجودين',
    search_by_name_or_email: 'البحث بالاسم أو  بالهاتف',
    select_appointment_slot: 'اختيار وقت الموعد',
    choose_provider_type_browse_available_slots: 'اختر نوع مقدم الخدمة وتصفح المواعيد المتاحة',
    select_provider_type: 'اختر نوع مقدم الخدمة',
    change_provider_type: 'تغيير نوع مقدم الخدمة',
    doctor: 'طبيب',
    nutritionist: 'اختصاصي تغذية',
    back: 'رجوع',
    available_slots_for: 'المواعيد المتاحة لـ',
    select_appointment_date_time_type: 'اختر تاريخ ووقت ونوع الموعد',
    appointment_type: 'نوع الموعد',
    virtual_consultation: 'استشارة عبر الإنترنت',
    in_person_visit: 'زيارة شخصية',
    provide_medical_details_and_any_relevant_documents: 'قدم التفاصيل الطبية وأي مستندات ذات صلة',
    symptoms_complaints: 'الأعراض / الشكاوى',
    describe_symptoms_reason_for_visit: 'وصف الأعراض أو سبب الزيارة',
    any_relevant_medical_history: 'أي تاريخ طبي ذي صلة',
    current_medications: 'الأدوية الحالية',
    allergies: 'الحساسية',
    list_any_allergies: 'اذكر أي حساسية',
    list_current_medications: 'اذكر الأدوية الحالية',
    any_additional_notes: 'أي ملاحظات إضافية',
    important_note: 'ملاحظة مهمة',
    ticket_creation_disclaimer:
      'من خلال إنشاء هذا الموعد، فإنك تؤكد أن جميع المعلومات المقدمة دقيقة وتوافق على مشاركة هذه المعلومات مع مقدم الرعاية الصحية.',
    create_ticket: 'إنشاء موعد',
    review_confirmation: 'مراجعة وتأكيد',
    review_msg: 'يرجى مراجعة تفاصيل الموعد قبل التأكيد',
    patient_selection_required: 'يجب اختيار المريض',
    speciality_selection_required: 'يجب اختيار الاختصاص و تاريخ الموعد',
    consultation_mode: 'وضع الاستشارة',
    initial_consultation: 'الاستشارة الأولية',
    followup_visit: 'زيارة المتابعة',
    urgent_care: 'رعاية عاجلة',
    routine_checkup: 'فحص روتيني',
    select_type: 'اختر النوع',
    medical_records: 'السجلات الطبية',
    rx: 'وصفة طبية',
    lab_result: 'نتيجة تحليل',
    scans: 'فحوصات',
    eye_report: 'تقرير عيون',
    others: 'أخرى',
    edit_patient_info: 'تعديل معلومات المريض',
    diabetes_information: 'معلومات السكر',
    lifestyle_factors: 'عوامل نمط الحياة',
    pregnancy_status: 'حالة الحمل',
    other_medical_conditions: 'حالات طبية أخرى',
    select_blood_type: 'اختر فصيلة الدم',
    enter_chronic_conditions: 'أدخل الحالات المزمنة',
    select_status: 'اختر الحالة',
    not_pregnant: 'غير حامل',
    pregnant: 'حامل',
    planning: 'تخطط للحمل',
    select_level: 'اختر المستوى',
    none: 'لا شيء',
    heavy: 'كثيف',
    never_smoker: 'لم يدخن أبدًا',
    former_smoker: 'مدخن سابق',
    current_smoker: 'مدخن حالي',
    select_gender: 'اختر الجنس',
    T1: 'سكري النوع الأول',
    T2: 'سكري النوع الثاني',
    GEST: 'سكري الحمل',
    PRE: 'ما قبل السكر',
    IDKY: 'نوع آخر محدد',
    moderate_smoking: 'معتدل',
    subscription_created_successfully: 'Subscription created successfully',
    changed_details: 'التفاصيل التي تم تغييرها',
    please_enter_valid_date: 'يرجى إدخال تاريخ صالح',
    note_added_successfully: 'تمت إضافة الملاحظة بنجاح',
    diastolic: 'الضغط الانبساطي',
    systolic: 'الضغط الانقباضي',
    please_select_a_resolving_reason: 'يرجى اختيار سبب الحل',
    please_type_a_resolving_comment: 'يرجى كتابة تعليق الحل',
    // Mahmoud

    // Fatma
    //LayOut
    menu: 'القائمة',
    dashboard: 'لوحة التحكم',
    calendar: 'جدول المواعيد',
    analytics: 'التحليلات',
    admin: 'إعدادات',
    admin_dashboard: 'لوحة تحكم الإعدادات',
    //Dashboard Page
    total_patients: 'إجمالي عدد المرضى',
    active_tickets: 'المواعيد النشطة الحالية',
    upcoming_appointments: 'المواعيد المستقبلية',
    appointments_trends: 'توجهات المواعيد',
    appointment_status_distribution: 'توزيع حالات المواعيد',
    recent_activity: 'آخر الأنشطة',
    no_appointments_trends: 'لا توجد بيانات متاحة للمواعيد',
    no_appointments_distribution: 'لا توجد بيانات متاحة لتوزيع المواعيد',
    view_details: 'عرض التفاصيل',
    no_recent_tickets: 'لا توجد مواعيد حديثة',
    invalida_date: 'تاريخ غير صالح',
    not_avaliable: 'غير متاح',
    ticket_created_on: 'تم إنشاء الموعد في',
    //Calendar
    has_no_permission: 'ليس لديك إذن للوصول إلى هذه الصفحة.',
    close: 'إغلاق',
    virtual: 'افتراضي',
    'in-person': 'شخصيًا',
    normal: 'عادي',
    emergency: 'طارئ',
    today: 'اليوم',
    calendar_month: 'الشهر',
    calendar_week: 'الأسبوع',
    calendar_day: 'اليوم',
    calendar_agenda: 'الجدول الزمني',
    all_statuses: ' جميع الحالات',
    all_types: ' جميع الأنواع',
    all_doctors: ' جميع الأطباء',
    calendar_sunday: 'الأحد',
    calendar_monday: 'الإثنين',
    calendar_tuesday: 'الثلاثاء',
    calendar_wednesday: 'الأربعاء',
    calendar_thursday: 'الخميس',
    calendar_friday: 'الجمعة',
    calendar_saturday: 'السبت',
    //companion messages
    companion_messages: 'رسالة المرافق',
    no_content_available: 'لا توجد محتويات متاحة',
    read: 'مقروءة',
    unread: 'غير مقروءة',
    previvous: 'السابق',
    no_comopanion_messages_found: 'لا توجد رسائل مرافقة',
    send_message: 'إرسال الرسالة',
    update_message: 'تعديل الرسالة',
    message: 'الرسالة',
    send_new_companion_message: 'إرسال رسالة مرافقة جديدة',
    please_enter_message: 'يرجى إدخال الرسالة',
    enter_your_message: 'أدخل رسالتك',
    upload_files: 'تحميل الملفات',
    //admin
    manage_roles_users: 'إدارة المستخدمين والأدوار وإعدادات النظام',
    total_users: 'إجمالي المستخدمين',
    users: 'المستخدمون',
    roles: 'الأدوار',
    audit_logs: 'سجلات التتبع',
    recommendations: 'التوصيات',
    search_users: 'ابحث عن المستخدمين...',
    all_roles: 'جميع الأدوار',
    active_status: 'نشط',
    inactive_status: 'غير نشط',
    add_user: 'إضافة مستخدم',
    user: 'مستخدم',
    role: 'دور',
    permissions: 'الأذونات',
    view_dashboard: 'عرض لوحة التحكم',
    view_patients: 'عرض المرضى',
    create_patient: 'إضافة مريض',
    edit_patient: 'تعديل مريض',
    delete_patient: 'حذف مريض',
    view_patient_profile: 'عرض ملف المريض',
    view_tickets: 'عرض المواعيد',
    edit_ticket: 'تعديل موعد',
    view_ticket_details: 'عرض تفاصيل الموعد',
    configure_alert_complain: 'إعداد تنبيهات الشكاوى',
    view_appointments: 'عرض المواعيد',
    create_appointment: 'إنشاء موعد',
    edit_appointment: 'تعديل الموعد',
    delete_appointment: 'حذف الموعد',
    view_appointment_details: 'عرض تفاصيل الموعد',
    appointment: 'موعد',
    export_appointments: 'تصدير المواعيد',
    completed_appointments: 'المواعيد المكتملة',
    appointment_timeline: 'جدول المواعيد',
    access_admin_panel: 'الوصول إلى لوحة الإعدادات',
    view_calendar: 'عرض جدول المواعيد',
    view_availability: 'عرض التوفر',
    update_availability: 'تحديث التوفر',
    view_analytics: 'عرض التحليلات',
    view_all_users_availability: 'عرض توفر جميع المستخدمين',
    view_plan_details: 'عرض تفاصيل الخطة',
    upload_doc_to_plan: 'رفع مستند إلى الخطة',
    delete_attachment: 'حذف المرفق',
    view_users_availability: 'عرض توفر المستخدمين',
    select_role: 'اختر دور',
    create_user: 'انشئ مستخدم',
    password: 'كلمة المرور',
    create_new_user: 'إضافة مستخدم جديدة',
    edit_user: 'تعديل المستخدم',
    update_user: 'تحديث المستخدم',
    delete_user: 'حذف المستخدم',
    confirm_delete_user: ' تاكيد حذف المستخدم',
    are_you_sure_you_want_to_delete: 'هل أنت متأكد من أنك تريد حذف',
    search_audit_logs: 'ابحث في سجلات التتبع...',
    all_actions: 'جميع الإجراءات',
    timestamp: 'الطابع الزمني',
    action: 'الإجراء',
    performed_by: 'تم بواسطة',
    showing: 'عرض',
    of: 'من',
    results: 'نتائج',
    requests: 'طلبات',
    no_appointments_yet: 'لا توجد مواعيد بعد',
    specialty: 'التخصص',
    missed: 'فائت',
    are_you_still_in_the_call: 'هل ما زلت في المكالمة؟',
    call_will_end_automatically_in: 'ستنتهي المكالمة تلقائياً خلال:',
    yes_still_here: 'أكمل المكالمة',
    close_details_popup: 'إغلاق نافذة التفاصيل',
    read_more: 'اقرأ المزيد...',
    role_management: 'إدارة الأدوار',
    create_role: 'إضافة دور',
    permissions_assigned: 'الأذونات المخصصة',
    create_new_role: 'إضافة دور جديد',
    role_name: 'اسم الدور',
    allow_user_to: 'يسمح للمستخدم بـ',
    update_role: 'تحديث الدور',
    this_cannot_be_undone: 'لا يمكن التراجع عن هذا',
    confirm_delete_role: 'تاكيد حذف الدور ',
    delete_role: 'حذف الدور ',
    edit_role: 'تعديل الدور ',
    email_notification: 'إشعارات البريد الإلكتروني',
    enable_email_notification: 'تفعيل إشعارات البريد الإلكتروني',
    send_email_notifications_for_important_events:
      'إرسال إشعارات البريد الإلكتروني للأحداث الهامة في النظام',
    new_ticket_notification: 'إشعارات موعد جديد',
    notify_agents_for_new_tickets: 'إشعار الوكلاء عند إنشاء مواعيد جديد',
    ticket_update_notifications: 'إشعارات تحديث الموعد',
    notify_users_for_update_tickets: 'إشعار المستخدمين عند تحديث مواعيدهم',
    system_alert_notifications: 'إشعارات تنبيهات النظام',
    recieve_notifictions_about_system_alerts: 'تلقي إشعارات حول تنبيهات النظام والتحديثات الهامة',
    security_settings: 'إعدادات الأمان',
    require_two_factor_authentication: 'طلب المصادقة الثنائية',
    enforce_two_factor_authentication: 'فرض المصادقة الثنائية لجميع المستخدمين',
    password_requirements: 'متطلبات كلمة المرور',
    require_strong_passwords: 'طلب كلمات مرور قوية',
    enable_password_expiration: 'تفعيل انتهاء صلاحية كلمة المرور',
    password_expiration_period: 'مدة انتهاء صلاحية كلمة المرور (أيام)',
    automated_tasks: 'المهام التلقائية',
    auto_close_inactive_tickets: 'إغلاق المواعيد غير النشطة تلقائيًا',
    archive_old_tickets: 'أرشفة المواعيد القديمة',
    default_appointment_duration: 'مدة الموعد الافتراضية',
    save_settings: 'حفظ الإعدادات',
    // plan_recommendations: 'توصيات الخطة',
    add_recommendation: 'إضافة توصية',
    severity_label: 'الخطورة',
    edit_recommendation: 'تعديل التوصية',
    create_recommendation: 'إضافة توصية',
    recommendation_name: 'اسم التوصية',
    enter_recommendation_name: 'أدخل اسم التوصية',
    conditions: 'الشروط',
    plan_details: 'تفاصيل الخطة',
    save_recommendation: 'حفظ التوصية',
    condition_type: 'نوع الشرط',
    condition_and: 'و (يجب تحقيق جميع الشروط)',
    condition_or: 'أو (يجب تحقيق شرط واحد على الأقل)',
    metric_conditions: 'شروط القياس',
    select_metric: 'اختر القياس',
    metric_bmi: 'مؤشر كتلة الجسم',
    metric_weight: 'الوزن',
    metric_blood_pressure: 'ضغط الدم',
    metric_blood_sugar: 'سكر الدم',
    metric_heart_rate: 'معدل ضربات القلب',
    operator_greater_than: 'أكبر من',
    operator_less_than: 'أقل من',
    operator_equal_to: 'يساوي',
    operator_greater_than_or_equal: 'أكبر من أو يساوي',
    operator_less_than_or_equal: 'أقل من أو يساوي',
    value_placeholder: 'القيمة',
    add_condition: 'إضافة شرط',
    plan_title: 'عنوان الخطة',
    enter_plan_title: 'أدخل عنوان الخطة',
    enter_plan_description: 'أدخل وصف الخطة',
    duration: 'المدة',
    duration_placeholder: 'مثال: 3 أشهر',
    recommended_actions: 'الإجراءات الموصى بها',
    enter_recommended_action: 'أدخل الإجراء الموصى به',
    add_action: 'إضافة إجراء',
    severity: 'الخطورة',
    severity_low: 'منخفض',
    severity_medium: 'متوسط',
    severity_high: 'عالي',
    tags: 'العلامات',
    add_tag_placeholder: 'إضافة وسم (اضغط Enter)',

    glucose_name: 'إدارة الجلوكوز',
    glucose_management_description: 'مقاييس حاسمة للتحكم في سكر الدم لمرضى السكري',
    fasting_blood_sugar_name: 'سكر الدم الصائم',
    fasting_blood_sugar_help: 'مستوى جلوكوز الدم بعد 8 ساعات أو أكثر من الصيام',
    post_prandial_glucose_name: 'سكر الدم بعد الوجبة',
    post_meal_blood_sugar_help: 'جلوكوز الدم بعد ساعتين من تناول الطعام',
    hba1c_name: 'HbA1c (A1C)',
    hba1c_help: 'متوسط سكر الدم خلال الأشهر الثلاثة الماضية',
    random_blood_sugar_name: 'سكر الدم العشوائي',
    random_blood_sugar_help: 'جلوكوز الدم في أي وقت من اليوم',
    vital_name: 'العلامات الحيوية المرتبطة بالسكري',
    diabetes_vital_signs_description: 'مؤشرات فسيولوجية رئيسية لإدارة مرض السكري',
    blood_pressure_name: 'ضغط الدم',
    blood_pressure_help: 'إدارة ضغط الدم لمرضى السكري',
    heart_rate_name: 'معدل ضربات القلب أثناء الراحة',
    resting_heart_rate_help: 'مؤشر معدل ضربات القلب لصحة القلب والأوعية الدموية',
    ketones_name: 'الكيتونات في الدم',
    blood_ketones_help: 'مستويات الكيتون للكشف عن احتمالية الحماض الكيتوني السكري',
    metabolic_name: 'مؤشرات الصحة الأيضية',
    metabolic_health_markers_description: 'مؤشرات أيضية شاملة لمرض السكري',
    cholesterol_name: 'الكوليسترول الكلي',
    total_cholesterol_help: 'مستويات الكوليسترول الحاسمة لمرضى السكري',
    ldl_cholesterol_name: 'الكوليسترول المنخفض الكثافة',
    ldl_cholesterol_help: 'البروتين الدهني منخفض الكثافة (الكوليسترول السيء)',
    hdl_cholesterol_name: 'الكوليسترول العالي الكثافة',
    hdl_cholesterol_help: 'البروتين الدهني عالي الكثافة (الكوليسترول الجيد)',
    triglycerides_name: 'الدهون الثلاثية',
    triglycerides_help: 'الدهون في الدم، مهمة لإدارة مرض السكري',
    please_fill_all_fields: 'يرجى ملء جميع الحقول المطلوبة',
    recommendation_levels_for: 'مستويات التوصية لـ',
    add_level: 'إضافة مستوى',
    minimum_value: 'القيمة الدنيا',
    maximum_value: 'القيمة العليا',
    color: 'اللون',
    yellow: 'أصفر',
    red: 'أحمر',
    green: 'أخضر',
    level_label: 'تسمية المستوى',
    recommendation_message_ar: 'رسالة التوصية بالعربية',
    recommendation_message_en: 'رسالة التوصية بالإنجليزية',

    add: 'إضافة',
    severity_color: 'لون الخطورة',
    remove_level: 'إزالة المستوى',
    no_recommendation_levels: 'لم يتم تحديد مستويات التوصية. أضف مستواك الأول.',
    unsaved_changes: 'تغييرات غير محفوظة',
    all_changes_saved: 'تم حفظ جميع التغييرات',
    overall_minimum_value: 'القيمة الدنيا الإجمالية',
    overall_maximum_value: 'القيمة العليا الإجمالية',
    diabetes_health_metrics: 'تكوين مقاييس صحة السكري',
    define_precise_thresholds: 'حدد عتبات وتوصيات دقيقة لإدارة مرض السكري',
    diabetes_metrics_configuration_guidelines: 'إرشادات تكوين مقاييس السكري',
    metric_custom_thresholds: 'كل مقياس لديه عتبات مخصصة مصممة لإدارة مرض السكري',
    recommendation_levels_diabetes: 'مستويات التوصية خاصة بمؤشرات الصحة المرتبطة بمرض السكري',
    color_coding_risk_levels:
      'الترميز اللوني يساعد في تحديد مستويات المخاطر بسرعة: أخضر (آمن)، أصفر (حذر)، أحمر (مخاطر عالية)',
    ranges_medical_guidelines: 'النطاقات والتوصيات مبنية على الإرشادات الطبية لرعاية مرض السكري',
    customize_levels_patient_needs:
      'تخصيص المستويات لتتناسب مع احتياجات المريض الفردية والنصائح الطبية',

    failed_to_load_admin_data_notification: 'فشل في تحميل بيانات الإعدادات',
    update_health_metrics_notification: 'تم تحديث مقاييس الصحة بنجاح',
    failed_to_update_health_metrics_notification: 'فشل في تحديث مقاييس الصحة',
    fill_in_required_fields_notification: 'يرجى ملء جميع الحقول المطلوبة',
    failed_to_create_user_notification: 'فشل في إضافة المستخدم',
    success_update_user_notification: 'تم تحديث المستخدم بنجاح',
    failed_to_update_user: 'فشل في تحديث المستخدم',
    user_deleted_successfully_notification: 'تم حذف المستخدم بنجاح',
    failed_to_delete_user: 'فشل في حذف المستخدم',
    role_created_successfully_notification: 'تم إضافة الدور بنجاح',
    failed_to_create_role: 'فشل في إضافة الدور',
    role_updated_successfully_notification: 'تم تحديث الدور بنجاح',
    failed_to_update_role: 'فشل في تحديث الدور',
    role_deleted_successfully_notification: 'تم حذف الدور بنجاح',
    failed_to_delete_role: 'فشل في حذف الدور',
    settings_updated_successfully_notification: 'تم تحديث الإعدادات بنجاح',
    recommendation_updated_successfully_notification: 'تم تحديث تكوين التوصية بنجاح',
    failed_to_save_recommendation: 'فشل في حفظ تكوين التوصية',
    select_chronic_conditions: 'اختر الحالات المزمنة',
    search_conditions: 'ابحث عن الحالات',
    select_allergies: 'اختر الحساسيات',

    health_metrics_config_updated: 'تحديث تكوين مقاييس الصحة',
    role_created: 'إضافة دور',
    role_updated: 'تحديث دور',
    role_deleted: 'حذف دور',
    ticket_created: 'إضافة موعد',
    ticket_updated: 'تحديث موعد',
    ticket_deleted: 'حذف موعد',
    comment_created: 'إضافة تعليق',
    medical_record_created: 'إضافة سجل طبي',
    attachment_deleted: 'حذف مرفق',
    patient_updated: 'تحديث بيانات المريض',
    patient_health_profile_updated: 'تحديث ملف الصحة للمريض',
    settings_updated: 'تحديث الإعدادات',
    region: 'المنطقة',
    all_regions: 'جميع المناطق',
    eg_region: 'مصر',
    sa_region: 'السعودية',
    select_speciality: 'اختر التخصص',
    speciality: 'التخصص',
    failed_to_fetch_specialities: 'فشل في تحميل التخصصات',
    expert_note: 'ملاحظة الخبير',
    yesterday: 'الأمس',
    expert_note_deleted_successfully: 'تم حذف الملاحظة بنجاح',
    failed_to_delete_expert_note: 'فشل في حذف الملاحظة',
    expert_note_created_successfully: 'تم إضافة الملاحظة بنجاح',
    failed_to_create_expert_note: 'فشل في إضافة الملاحظة',
    save: 'حفظ',
    expert_note_is_required: 'ملاحظة الخبير مطلوبة',
    // Specialty Management
    specialties: 'التخصصات',
    specialty_name: 'اسم التخصص',
    add_specialty: 'إضافة تخصص',
    edit_specialty: 'تعديل التخصص',
    delete_specialty: 'حذف التخصص',
    confirm_delete_specialty:
      'هل أنت متأكد أنك تريد حذف هذا التخصص؟ لا يمكن التراجع عن هذا الإجراء.',
    specialty_already_exists: 'يوجد تخصص بهذا الاسم بالفعل',
    specialty_added_successfully: 'تمت إضافة التخصص بنجاح',
    specialty_updated_successfully: 'تم تحديث التخصص بنجاح',
    specialty_deleted_successfully: 'تم حذف التخصص بنجاح',
    specialty_activated_successfully: 'تم تفعيل التخصص بنجاح',
    specialty_deactivated_successfully: 'تم إلغاء تفعيل التخصص بنجاح',
    failed_to_load_specialties: 'فشل في تحميل التخصصات',
    failed_to_add_specialty: 'فشل في إضافة التخصص',
    failed_to_update_specialty: 'فشل في تحديث التخصص',
    failed_to_delete_specialty: 'فشل في حذف التخصص',
    failed_to_update_specialty_status: 'فشل في تحديث حالة التخصص',
    search_specialties: 'البحث في التخصصات',
    no_specialties_found: 'لم يتم العثور على تخصصات',
    english: 'الإنجليزية',
    arabic: 'العربية',
    view_in_expert_note: 'عرض في ملاحظة الخبير',
    no_specialities_found: 'لم يتم العثور على تخصصات',
    search_speciality: 'ابحث عن تخصص',
    failed_to_update_status: 'فشل في تحديث الحالة',
    change_status_to_waiting_for_action: 'تغيير الحالة إلى في انتظار الإجراء',
    close_ticket: 'إغلاق التذكرة',
    are_you_sure_do_you_want_to_close_this_ticket: 'هل أنت متأكد أنك تريد إتمام هذا الحجز؟',
    first_name: 'الاسم الاول',
    last_name: 'الاسم الاخير',
    invalid_phone_number: 'رقم الهاتف غير صالح',
    invalid_email: 'البريد الإلكتروني غير صالح',
    chatbot_tickets: 'تذاكر الدردشة الآلية',
    created_date: 'تم إنشاء',
    updated_date: 'تم التحديث',
    chatbot_search_placeholder:
      'البحث حسب اسم المريض، أو المعرف الخارجي، أو الهاتف، أو رقم التذكرة ...',
    lab_result_inquiry: 'استفسار عن نتائج المختبر',
    medical_appointment: 'موعد طبي',
    chatbot_complaint: 'شكوى',
    appointment_type_required: 'يجب اختيار نوع الموعد',
    symptoms_required: 'يجب ادخال الأعراض',
    active: 'نشط',
    please_enter_valid_phone_number: 'يرجى إدخال رقم هاتف صالح',
    created_at: 'تاريخ الإنشاء',
    freeTrial: 'تجربة مجانية',
    health_history: 'سجل الصحة',
    diary_name: 'اسم التسجيل',
    time: 'الوقت',
    reading: 'القراءة',
    all_diaries: 'جميع اليوميات',
    workout: 'التمارين',
    water: 'الماء',
    carbohydrates: 'الكربوهيدرات',
    error_fetching_health_records: 'فشل في تحميل سجلات الصحة',
    no_diary_entries: 'لا يوجد سجلات يومية تم العثور عليها',
    range_of_date: 'مدة التاريخ',
    date_from: 'من تاريخ',
    date_to: 'إلى تاريخ',
    date_from_cannot_be_after_date_to: 'تاريخ البدء لا يمكن أن يكون بعد تاريخ النهاية',
    date_from_and_date_to_are_required_to_apply: 'يجب أن يتم إدخال تاريخ البدء وتاريخ النهاية',
    hr: ' ساعة',
    min: ' دقيقة',
    no_historical_data_available_for_this_metric_yet:
      'لا يوجد بيانات تاريخية متاحة لهذا القياس بعد الآن',
    notification_center: 'مركز الاشعارات',
    notifications_list: 'قائمة الإشعارات',
    create_notification: 'إنشاء إشعار',
    total_number_of_notifications: 'إجمالي عدد الإشعارات',
    total_recipients: 'إجمالي المستلمين',
    clicked: 'تم النقر',
    total_scheduled: 'إجمالي المجدولة',
    upcoming: 'قادم',
    search_notification_title_placeholder: 'البحث عن عنوان الإشعار...',
    all_status: 'جميع الحالات',
    sent: 'تم الإرسال',
    scheduled: 'مجدول',
    performance: 'الأداء',
    no_clicks: 'لا توجد نقرات',
    clicks: 'نقرة',
    notification_view: 'عرض الإشعار',
    view_detailed_information_about_this_notification: 'عرض معلومات مفصلة حول هذا الإشعار',
    call_to_action: 'الاجراء المتخذ',
    sent_date: 'تاريخ الإرسال',
    sent_time: 'وقت الإرسال',
    performance_metrics: 'مقاييس الأداء',
    total_clicks: 'إجمالي النقرات',
    ctr: 'نسبة النقر إلى الظهور (CTR)',
    notification_template_deleted_successfully: 'تم حذف قالب الإشعار بنجاح',
    failed_to_delete_notification_template: 'فشل حذف قالب الإشعار',
    failed_to_export_notifications_data: 'فشل تصدير بيانات الإشعارات.',
    select_date: 'اختر التاريخ',
    no_date_selected: 'لم يتم اختيار تاريخ',
    january: 'يناير',
    february: 'فبراير',
    march: 'مارس',
    april: 'أبريل',
    may: 'مايو',
    june: 'يونيو',
    july: 'يوليو',
    august: 'أغسطس',
    september: 'سبتمبر',
    october: 'أكتوبر',
    november: 'نوفمبر',
    december: 'ديسمبر',
    su: 'الأحد',
    mo: 'الاثنين',
    tu: 'الثلاثاء',
    we: 'الأربعاء',
    th: 'الخميس',
    fr: 'الجمعة',
    sa: 'السبت',
    recipients: 'المستلمين',
    audience: 'الجمهور',
    notifications_report: 'تقرير-الإشعارات',
    group_users: 'مجموعة مستخدمين',
    send_now: 'إرسال الآن',
    schedule: 'جدولة',
    send_test: 'إرسال تجريبي',
    no_notifications_yet: 'لا توجد إشعارات بعد',
    get_started_notifications: 'ابدأ بإنشاء إشعارك الأول للتفاعل مع مستخدميك',
    continue_to_content: 'الاستمرار إلى المحتوى',
    continue_to_review: 'الاستمرار إلى المراجعة',
    select_audience: 'اختر الجمهور',
    estimated_receipients: 'عدد المستلمين المتوقع',
    user_group: 'مجموعة المستخدمين',
    search_users_hint: 'البحث بالاسم، أو رقم الهاتف، أو المعرّف',
    filter_by_criteria: 'التصفية حسب المعايير',
    all: 'الكل',
    active_7_days_ago: 'نشط خلال آخر 7 أيام',
    active_14_days_ago: 'نشط خلال آخر 14 يوم',
    inactive_7_days_ago: 'غير نشط منذ 7 أيام',
    inactive_14_days_ago: 'غير نشط منذ 14 يوم',
    inactive_30_days_ago: 'ير نشط منذ 30 يوم',
    wellness: 'الصحة',
    weight_loss: 'خسارة الوزن',
    rest_of_the_world: 'بقية العالم',
    target_condition: 'الحالة الصحية المستهدفة',
    user_activity: 'نشاط المستخدم',
    age_group: 'الفئة العمرية',
    subscription_status: 'لاشتراك',
    notification_title: 'عنوان الإشعار',
    egypt: 'مصر',
    subscribed: 'مشترك',
    unsubscribed: 'غير مشترك',
    KSA: 'السعودية',
    continue_to_preview: 'الاستمرار في المعاينة',
    estimated_recipients: 'عدد المستلمين المتوقع',
    whitelist_management: 'إدارة القائمة البيضاء',
    choose_who_will_receive_the_test_notification: 'اختر من يتلقى الإشعار التجريبي',
    whitelist: 'القائمة البيضاء',
    no_users_in_whitelist: 'لا يوجد مستخدمين في القائمة البيضاء',
    switch_to_search_users_to_add_users: 'ابدأ بالبحث عن المستخدمين لإضافتهم إلى القائمة البيضاء',
    no_users_exists: 'لا يوجد مستخدمين',
    try_again_with_different_search: 'حاول مرة أخرى باستخدام بحث مختلف',
    searching: 'جاري البحث',
    added: 'تم الإضافة',
    deselect_all: 'إلغاء التحديد',
    select_all: 'تحديد الكل',
    review: 'مراجعة',
    Subscribed: 'مشترك',
    notification_content: 'محتوى الإشعار',
    this_will_disconnect_the_video_consultation_with_the_patient:
      'سيؤدي هذا إلى قطع الاتصال مع المريض.',
    end_call: 'إنهاء المكالمة',
    select_reason_for_ending_consultation: 'اختر سبب إنهاء الاستشارة',
    this_will_cancel_the_patient_appointment:
      'سيؤدي هذا إلى إلغاء موعد المريض مع الطبيب، هل أنت متأكد؟',
    yes_cancel: 'نعم، إلغاء',
    no_keep_it: 'رجوع',
    select_reason_for_cancel_consultation: 'اختر سبب إلغاء الاستشارة',
    consultation_completed: 'تمت الاستشارة',
    patient_did_not_join_the_call: 'لم ينضم المريض إلى المكالمة',
    poor_internet_connection: 'اتصال إنترنت ضعيف',
    technical_audio_issue: 'مشكلة تقنية/صوتية',
    emergency_interruption: 'انقطاع طارئ',
    patient_requested_to_end_the_session: 'طلب المريض إنهاء الجلسة',
    submit: 'إرسال',
    type_something: 'اكتب شيئا',
    brief_en: 'نبذة باللغة الإنجليزية',
    brief_ar: 'نبذة باللغة العربية',
    brief_en_placeholder: 'Write a professional Brief in English (min. 20 characters)..',
    brief_ar_placeholder: 'سيرة ذاتية قصيرة أو معلومات مهنية عن الطبيب...',
    brief_min_length_error: 'يجب أن تكون النبذة 20 حرفاً على الأقل.',
    characters_counter: 'حرف',

    // Complain alerts configuration
    configure_complain_alerts: 'إعداد تنبيهات الشكاوى',
    configure_complain_alerts_subtitle: 'اختر متى يتم تنبيه فريقك بشأن تذاكر الشكاوى.',
    notify_on_new_ticket_creation: 'تنبيه عند إنشاء تذكرة جديدة',
    notify_on_new_ticket_creation_hint: 'إرسال بريد إلكتروني فوراً عند فتح المريض لتذكرة.',
    notify_when_there_is_no_response: 'تنبيه عند عدم الرد',
    notify_when_there_is_no_response_hint:
      'إرسال تنبيهات تلقائية إذا لم يقم الموظف بالرد خلال المدة المحددة.',
    recipient_emails_type_and_press_enter: 'البريد الإلكتروني للمستلمين (اكتب واضغط Enter)',
    no_response_schedule_actions: 'جدول عدم الرد (الإجراءات)',
    send_email_to: 'إرسال بريد إلكتروني إلى:',
    send_email_after: 'إرسال بريد إلكتروني بعد',
    hour_s: 'ساعة/ساعات',
    add_another_reminder_timer: 'إضافة مؤقت تذكير آخر',
    remove_reminder_timer: 'حذف مؤقت التذكير',
    email_example_placeholder: 'مثال agent@dru-app.com',
    add_another_email_placeholder: 'أضف بريداً آخر...',
    please_enter_a_valid_email_format: 'يرجى إدخال بريد إلكتروني بصيغة صحيحة',
    failed_to_save_alert_settings: 'فشل حفظ إعدادات التنبيهات',

    // Add diary drawer
    add_health_record: 'إضافة سجل صحي',
    update_vitals_and_metrics: 'تحديث القياسات الحيوية',
    what_to_log: 'ماذا تريد أن تسجل؟',
    what_to_log_hint: 'اختر فئة لتسجيل سجل صحي جديد أو لإدارة أدوية هذا المريض.',
    patient_diary: 'يوميات المريض',
    patient_diary_hint: 'الصحة ونمط الحياة',
    patient_medication: 'أدوية المريض',
    patient_medication_hint: 'إدارة الأدوية وتحديد الجرعات وجدولة التذكيرات.',
    coming_soon: 'قريباً',
    diary: 'اليوميات',
    diary_hint: 'يمكنك اختيار قراءة واحدة أو أكثر من الخيارات أدناه لتحديث يوميات المريض.',
    waist: 'محيط الخصر',
    life_style: 'نمط الحياة',
    record_selected: 'قراءة محددة',
    add_logs: 'إضافة السجلات',
    done: 'تم',
    save_record: 'حفظ السجل',
    undo: 'تراجع',
    record_added_successfully: 'تمت إضافة السجل بنجاح',
    // Medication setup (doctor-logged prescriptions and doses)
    list_of_all_medications: 'قائمة جميع الأدوية',
    add_new_medication: 'إضافة دواء جديد',
    medication_details: 'تفاصيل الدواء',
    medication_name: 'اسم الدواء',
    choose_medication: 'اختر الدواء',
    no_medications_add_new: 'لا توجد أدوية، يمكنك إضافة دواء جديد.',
    no_medications_found: 'لا توجد أدوية',
    search_medication: 'ابحث عن دواء',
    clear_selection: 'إلغاء الاختيار',
    how_many_times_per_day: 'كم مرة في اليوم',
    forever: 'إلى الأبد',
    specific_number_of_days: 'عدد محدد من الأيام',
    reminders: 'التذكيرات',
    reminder: 'تذكير',
    add_to_list: 'اكمل',
    dosage: 'الجرعة',
    select_more_than_one: 'يمكنك اختيار أكثر من واحد',
    medication_added_successfully: 'تمت إضافة الدواء بنجاح',
    dosage_added_successfully: 'تمت إضافة الجرعة بنجاح',
    err_select_medication: 'اختر دواءً أولاً',
    err_field_required: 'هذا الحقل مطلوب',
    err_duration: 'يجب أن تكون المدة يوماً واحداً على الأقل',
    err_reminder_required: 'كل تذكير يحتاج إلى وقت',
    err_save_medication: 'فشل حفظ الدواء',
    err_dose_required: 'أدخل الجرعة والتاريخ والوقت',
    err_save_dose: 'فشل حفظ الجرعة',
    err_load_medications: 'فشل تحميل الأدوية',
    value: 'القيمة',
    duration_hours: 'ساعات',
    duration_minutes: 'دقائق',
    types: 'النوع',
    intensity: 'الشدة',
    notes_placeholder: 'أضف ملاحظة عن هذه القراءة',
    select_tags: 'اختر العلامات',
    select_meal: 'اختر الوجبة',
    select_intensity: 'اختر الشدة',
    select_amount: 'اختر الكمية',
    add_image: 'إضافة صورة',
    click_to_upload_image: 'اضغط لرفع صورة',
    image_hint: 'PNG أو JPG بحد أقصى 2 ميجابايت',
    image_type_error: 'يُقبل فقط PNG أو JPG',
    image_size_error: 'يجب ألا تتجاوز الصورة 2 ميجابايت',
    remove_image: 'إزالة الصورة',
    delete_metric: 'إزالة هذه القراءة',
    err_value_required: 'أدخل قيمة',
    err_value_positive: 'يجب أن تكون القيمة أكبر من صفر',
    err_value_max: 'القيمة خارج النطاق المقبول',
    err_bp_format: 'استخدم صيغة الانقباضي/الانبساطي مثل 120/80',
    err_bp_order: 'يجب أن يكون الانبساطي أقل من الانقباضي',
    err_duration_required: 'أدخل المدة',
    err_minutes_range: 'يجب أن تكون الدقائق أقل من 60',
    err_portion_required: 'اختر الكمية',
    err_date_required: 'اختر التاريخ والوقت',
    undo_success: 'لم يتم حفظ السجل',
    undo_failed: 'تعذر التراجع عن السجل. احفظ مرة أخرى للكتابة فوقه.',
    steps: 'الخطوات',
    steps_unit: 'خطوة',
    there_is_no_readings: 'لا توجد قراءات',
    medication_unavailable: 'دواء غير متاح',
    view_medications: 'عرض الأدوية',
    add_medication: 'إضافة دواء',
    delete_medication: 'حذف الدواء',
    view_reminders: 'عرض التذكيرات',
    confirm_password: 'تأكيد كلمة المرور',
    appointment_deleted_successfully: 'تم حذف الموعد بنجاح',
    consolation_mode: 'وضع الاستشارة',
    urget_care: 'رعاية عاجلة',
    single_users: 'مستخدمون محددون',
    test: 'اختبار',
    view_notification_center: 'عرض مركز الإشعارات',
  },
};
export const getText = (key) => {
  // this line is here as when user logout and login again it keep the pervious language
  let lang = localStorage.getItem('language');
  if (!lang) {
    lang = 'en';
  }

  return MultilanguageText?.[lang]?.[key] ?? key;
};

const enKeys = Object.keys(MultilanguageText.en);
const arKeys = Object.keys(MultilanguageText.ar);
if (enKeys.length !== arKeys.length) {
  throw new Error(`Number of keys in en (${enKeys.length}) and ar (${arKeys.length}) do not match`);
}
if (enKeys.values !== arKeys.values) {
  throw new Error(`Keys in en (${enKeys}) and ar (${arKeys}) do not match`);
}

//APP LOCAL ENUMS
export const AppLocalEnum = {
  EN: 'en',
  AR: 'ar',
  EN_US: 'en-US',
  AR_RG: 'ar-EG',
};

export const getLanguage = (code: string) => {
  return code === AppLocalEnum.AR ? AppLocalEnum.AR : AppLocalEnum.EN;
};
